(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[345],{

/***/ 8720:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;
__webpack_unused_export__ = ({value:!0});var n=__webpack_require__(9496);function t(n){return Array.prototype.slice.call(n)}function e(n,t){var e=Math.floor(n);return e===t||e+1===t?n:t}function i(){return Date.now()}function r(n,t,e){if(t="data-keen-slider-"+t,null===e)return n.removeAttribute(t);n.setAttribute(t,e||"")}function a(n,e){return e=e||document,"function"==typeof n&&(n=n(e)),Array.isArray(n)?n:"string"==typeof n?t(e.querySelectorAll(n)):n instanceof HTMLElement?[n]:n instanceof NodeList?t(n):[]}function o(n){n.raw&&(n=n.raw),n.cancelable&&!n.defaultPrevented&&n.preventDefault()}function u(n){n.raw&&(n=n.raw),n.stopPropagation&&n.stopPropagation()}function c(){var n=[];return{add:function(t,e,i,r){t.addListener?t.addListener(i):t.addEventListener(e,i,r),n.push([t,e,i,r])},input:function(n,t,e,i){this.add(n,t,function(n){return function(t){t.nativeEvent&&(t=t.nativeEvent);var e=t.changedTouches||[],i=t.targetTouches||[],r=t.detail&&t.detail.x?t.detail:null;return n({id:r?r.identifier?r.identifier:"i":i[0]?i[0]?i[0].identifier:"e":"d",idChanged:r?r.identifier?r.identifier:"i":e[0]?e[0]?e[0].identifier:"e":"d",raw:t,x:r&&r.x?r.x:i[0]?i[0].screenX:r?r.x:t.pageX,y:r&&r.y?r.y:i[0]?i[0].screenY:r?r.y:t.pageY})}}(e),i)},purge:function(){n.forEach((function(n){n[0].removeListener?n[0].removeListener(n[2]):n[0].removeEventListener(n[1],n[2],n[3])})),n=[]}}}function s(n,t,e){return Math.min(Math.max(n,t),e)}function d(n){return(n>0?1:0)-(n<0?1:0)||+n}function l(n){var t=n.getBoundingClientRect();return{height:e(t.height,n.offsetHeight),width:e(t.width,n.offsetWidth)}}function f(n,t,e,i){var r=n&&n[t];return null==r?e:i&&"function"==typeof r?r():r}function p(n){return Math.round(1e6*n)/1e6}function v(n,t){if(n===t)return!0;var e=typeof n;if(e!==typeof t)return!1;if("object"!==e||null===n||null===t)return"function"===e&&n.toString()===t.toString();if(n.length!==t.length||Object.getOwnPropertyNames(n).length!==Object.getOwnPropertyNames(t).length)return!1;for(var i in n)if(!v(n[i],t[i]))return!1;return!0}function h(n,t){return v(n.current,t)||(n.current=t),n.current}var m=function(){return m=Object.assign||function(n){for(var t,e=1,i=arguments.length;e<i;e++)for(var r in t=arguments[e])Object.prototype.hasOwnProperty.call(t,r)&&(n[r]=t[r]);return n},m.apply(this,arguments)};function g(n,t,e){if(e||2===arguments.length)for(var i,r=0,a=t.length;r<a;r++)!i&&r in t||(i||(i=Array.prototype.slice.call(t,0,r)),i[r]=t[r]);return n.concat(i||Array.prototype.slice.call(t))}function b(n){var t,e,i,r,a,o;function u(t){o||(o=t),c(!0);var a=t-o;a>i&&(a=i);var l=r[e];if(l[3]<a)return e++,u(t);var f=l[2],p=l[4],v=l[0],h=l[1]*(0,l[5])(0===p?1:(a-f)/p);if(h&&n.track.to(v+h),a<i)return d();o=null,c(!1),s(null),n.emit("animationEnded")}function c(n){t.active=n}function s(n){t.targetIdx=n}function d(){var n;n=u,a=window.requestAnimationFrame(n)}function l(){var t;t=a,window.cancelAnimationFrame(t),c(!1),s(null),o&&n.emit("animationStopped"),o=null}return t={active:!1,start:function(t){if(l(),n.track.details){var a=0,o=n.track.details.position;e=0,i=0,r=t.map((function(n){var t,e=o,r=null!==(t=n.earlyExit)&&void 0!==t?t:n.duration,u=n.easing,c=n.distance*u(r/n.duration)||0;o+=c;var s=i;return i+=r,a+=c,[e,n.distance,s,i,n.duration,u]})),s(n.track.distToIdx(a)),d(),n.emit("animationStarted")}},stop:l,targetIdx:null}}function y(n){var t,e,r,a,o,u,c,l,v,h,m,b,y,x,w=1/0,k=[],M=null,T=0;function C(n){P(T+n)}function E(n){var t=z(T+n).abs;return O(t)?t:null}function z(n){var t=Math.floor(Math.abs(n/e)),i=p((n%e+e)%e),r=d(n),a=c.indexOf(g([],c,!0).reduce((function(n,t){return Math.abs(t-i)<Math.abs(n-i)?t:n}))),o=a;return r<0&&0!==i&&t++,a===u&&(o=0,t+=r>0?1:-1),{abs:o+t*u*r,origin:a,rel:o}}function I(n,t,e){var i;if(t||!S())return A(n,e);if(!O(n))return null;var r=z(null!=e?e:T),a=r.abs,o=n-r.rel,c=a+o;i=A(c);var s=A(c-u*d(o));return(null!==s&&Math.abs(s)<Math.abs(i)||null===i)&&(i=s),p(i)}function A(n,t){if(null==t&&(t=p(T)),!O(n)||null===n)return null;n=Math.round(n);var i=z(t),r=i.abs,a=i.rel,o=i.origin,s=L(n),d=(t%e+e)%e,l=c[o],f=Math.floor((n-(r-a))/u)*e;return p(l-d-l+c[s]+f+(o===u?e:0))}function O(n){return D(n)===n}function D(n){return s(n,v,h)}function S(){return a.loop}function L(n){return(n%u+u)%u}function P(t){var e;e=t-T,k.push({distance:e,timestamp:i()}),k.length>6&&(k=k.slice(-6)),T=Math.round(1e6*t)/1e6;var r=_().abs;if(r!==M){var a=null!==M;M=r,a&&n.emit("slideChanged")}}function _(i){var c=i?null:function(){if(u){var n=S(),t=n?(T%e+e)%e:T,i=(n?T%e:T)-o[0][2],c=0-(i<0&&n?e-Math.abs(i):i),s=0,l=z(T),f=l.abs,p=l.rel,g=o[p][2],w=o.map((function(t,i){var r=c+s;(r<0-t[0]||r>1)&&(r+=(Math.abs(r)>e-1&&n?e:0)*d(-r));var o=i-p,l=d(o),v=o+f;n&&(-1===l&&r>g&&(v+=u),1===l&&r<g&&(v-=u),null!==m&&v<m&&(r+=e),null!==b&&v>b&&(r-=e));var h=r+t[0]+t[1],y=Math.max(r>=0&&h<=1?1:h<0||r>1?0:r<0?Math.min(1,(t[0]+r)/t[0]):(1-r)/t[0],0);return s+=t[0]+t[1],{abs:v,distance:a.rtl?-1*r+1-t[0]:r,portion:y,size:t[0]}}));return f=D(f),p=L(f),{abs:D(f),length:r,max:x,maxIdx:h,min:y,minIdx:v,position:T,progress:n?t/e:T/r,rel:p,slides:w}}}();return t.details=c,n.emit("detailsChanged"),c}return t={absToRel:L,add:C,details:null,distToIdx:E,idxToDist:I,init:function(t){if(function(){if(a=n.options,o=(a.trackConfig||[]).map((function(n){return[f(n,"size",1),f(n,"spacing",0),f(n,"origin",0)]})),u=o.length){e=p(o.reduce((function(n,t){return n+t[0]+t[1]}),0));var t,i=u-1;r=p(e+o[0][2]-o[i][0]-o[i][2]-o[i][1]),c=o.reduce((function(n,e){if(!n)return[0];var i=o[n.length-1],r=n[n.length-1]+(i[0]+i[2])+i[1];return r-=e[2],n[n.length-1]>r&&(r=n[n.length-1]),r=p(r),n.push(r),(!t||t<r)&&(l=n.length-1),t=r,n}),null),0===r&&(l=0),c.push(e)}}(),!u)return _(!0);var i;!function(){var t=n.options.range,e=n.options.loop;m=v=e?f(e,"min",-1/0):0,b=h=e?f(e,"max",w):l;var i=f(t,"min",null),r=f(t,"max",null);i&&(v=i),r&&(h=r),y=v===-1/0?v:n.track.idxToDist(v||0,!0,0),x=h===w?h:I(h,!0,0),null===r&&(b=h),f(t,"align",!1)&&h!==w&&0===o[L(h)][2]&&(x-=1-o[L(h)][0],h=E(x)),y=p(y),x=p(x)}(),i=t,Number(i)===i?C(A(D(t))):_()},to:P,velocity:function(){var n=i(),t=k.reduce((function(t,e){var i=e.distance,r=e.timestamp;return n-r>200||(d(i)!==d(t.distance)&&t.distance&&(t={distance:0,lastTimestamp:0,time:0}),t.time&&(t.distance+=i),t.lastTimestamp&&(t.time+=r-t.lastTimestamp),t.lastTimestamp=r),t}),{distance:0,lastTimestamp:0,time:0});return t.distance/t.time||0}}}function x(n){var t,e,i,r,a,o,u;function c(n){return 2*n}function l(n){return s(n,o,u)}function f(n){return 1-Math.pow(1-n,3)}function p(){m();var t="free-snap"===n.options.mode,e=n.track,o=e.velocity();i=d(o);var u=n.track.details,s=[];if(o||!t){var p=v(o),h=p.dist,g=p.dur;if(g=c(g),h*=i,t){var b=e.idxToDist(e.distToIdx(h),!0);b&&(h=b)}s.push({distance:h,duration:g,easing:f});var y=u.position,x=y+h;if(x<r||x>a){var w=x<r?r-y:a-y,k=0,M=o;if(d(w)===i){var T=Math.min(Math.abs(w)/Math.abs(h),1),C=function(n){return 1-Math.pow(1-n,1/3)}(T)*g;s[0].earlyExit=C,M=o*(1-T)}else s[0].earlyExit=0,k+=w;var E=v(M,100),z=E.dist*i;n.options.rubberband&&(s.push({distance:z,duration:c(E.dur),easing:f}),s.push({distance:-z+k,duration:500,easing:f}))}n.animator.start(s)}else n.moveToIdx(l(u.abs),!0,{duration:500,easing:function(n){return 1+--n*n*n*n*n}})}function v(n,t){void 0===t&&(t=1e3);var e=147e-9+(n=Math.abs(n))/t;return{dist:Math.pow(n,2)/e,dur:n/e}}function h(){var t=n.track.details;t&&(r=t.min,a=t.max,o=t.minIdx,u=t.maxIdx)}function m(){n.animator.stop()}n.on("updated",h),n.on("optionsChanged",h),n.on("created",h),n.on("dragStarted",(function(){m(),t=e=n.track.details.abs})),n.on("dragEnded",(function(){var i=n.options.mode;"snap"===i&&function(){var i=n.track,o=n.track.details,u=o.position,c=d(i.velocity());(u>a||u<r)&&(c=0);var s=t+c;0===o.slides[i.absToRel(s)].portion&&(s-=c),t!==e&&(s=e),d(i.idxToDist(s,!0))!==c&&(s+=c),s=l(s);var f=i.idxToDist(s,!0);n.animator.start([{distance:f,duration:500,easing:function(n){return 1+--n*n*n*n*n}}])}(),"free"!==i&&"free-snap"!==i||p()})),n.on("dragged",(function(){e=n.track.details.abs}))}function w(n){var t,e,i,l,f,p,v,h,m,g,b,y,x,w,k,M,T,C,E=c();function z(a){if(p&&h===a.id){var c=D(a);if(m){if(!O(a))return A(a);g=c,m=!1,n.emit("dragChecked")}if(M)return g=c;o(a);var x=function(t){if(T===-1/0&&C===1/0)return t;var i=n.track.details,r=i.length,a=i.position,o=s(t,T-a,C-a);if(0===r)return 0;if(!n.options.rubberband)return o;if(a<=C&&a>=T)return t;if(a<T&&e>0||a>C&&e<0)return t;var u=(a<T?a-T:a-C)/r,c=l*r,d=Math.abs(u*c),p=Math.max(0,1-d/f*2);return p*p*t}(v(g-c)/l*i);e=d(x);var w=n.track.details.position;(w>T&&w<C||w===T&&e>0||w===C&&e<0)&&u(a),b+=x,!y&&Math.abs(b*l)>5&&(y=!0,r(t,"moves","")),n.track.add(x),g=c,n.emit("dragged")}}function I(t){!p&&n.track.details&&n.track.details.length&&(y=!1,b=0,p=!0,m=!0,h=t.id,O(t),g=D(t),n.emit("dragStarted"))}function A(e){p&&h===e.idChanged&&(r(t,"moves",null),p=!1,n.emit("dragEnded"))}function O(n){var t=S(),e=t?n.y:n.x,i=t?n.x:n.y,r=void 0!==x&&void 0!==w&&Math.abs(w-i)<=Math.abs(x-e);return x=e,w=i,r}function D(n){return S()?n.y:n.x}function S(){return n.options.vertical}function L(){l=n.size,f=S()?window.innerHeight:window.innerWidth;var t=n.track.details;t&&(T=t.min,C=t.max)}function P(){if(E.purge(),n.options.drag&&!n.options.disabled){var e;e=n.options.dragSpeed||1,v="function"==typeof e?e:function(n){return n*e},i=n.options.rtl?-1:1,L(),t=n.container,function(){var n="data-keen-slider-clickable";a("[".concat(n,"]:not([").concat(n,"=false])"),t).map((function(n){E.add(n,"mousedown",u),E.add(n,"touchstart",u)}))}(),E.add(t,"dragstart",(function(n){o(n)})),E.input(t,"ksDragStart",I),E.input(t,"ksDrag",z),E.input(t,"ksDragEnd",A),E.input(t,"mousedown",I),E.input(t,"mousemove",z),E.input(t,"mouseleave",A),E.input(t,"mouseup",A),E.input(t,"touchstart",I,{passive:!0}),E.input(t,"touchmove",z,{passive:!1}),E.input(t,"touchend",A),E.input(t,"touchcancel",A),E.add(window,"wheel",(function(n){p&&o(n)}));var r="data-keen-slider-scrollable";a("[".concat(r,"]:not([").concat(r,"=false])"),n.container).map((function(n){return function(n){var t;E.input(n,"touchstart",(function(n){t=D(n),M=!0,k=!0}),{passive:!0}),E.input(n,"touchmove",(function(e){var i=S(),r=i?n.scrollHeight-n.clientHeight:n.scrollWidth-n.clientWidth,a=t-D(e),u=i?n.scrollTop:n.scrollLeft,c=i&&"scroll"===n.style.overflowY||!i&&"scroll"===n.style.overflowX;if(t=D(e),(a<0&&u>0||a>0&&u<r)&&k&&c)return M=!0;k=!1,o(e),M=!1})),E.input(n,"touchend",(function(){M=!1}))}(n)}))}}n.on("updated",L),n.on("optionsChanged",P),n.on("created",P),n.on("destroyed",E.purge)}function k(n){var t,e,i=null;function r(t,e,i){n.animator.active?o(t,e,i):requestAnimationFrame((function(){return o(t,e,i)}))}function a(){r(!1,!1,e)}function o(e,r,a){var o=0,u=n.size,d=n.track.details;if(d&&t){var l=d.slides;t.forEach((function(n,t){if(e)!i&&r&&c(n,null,a),s(n,null,a);else{if(!l[t])return;var d=l[t].size*u;!i&&r&&c(n,d,a),s(n,l[t].distance*u-o,a),o+=d}}))}}function u(t){return"performance"===n.options.renderMode?Math.round(t):t}function c(n,t,e){var i=e?"height":"width";null!==t&&(t=u(t)+"px"),n.style["min-"+i]=t,n.style["max-"+i]=t}function s(n,t,e){if(null!==t){t=u(t);var i=e?t:0;t="translate3d(".concat(e?0:t,"px, ").concat(i,"px, 0)")}n.style.transform=t,n.style["-webkit-transform"]=t}function d(){t&&(o(!0,!0,e),t=null),n.on("detailsChanged",a,!0)}function l(){r(!1,!0,e)}function p(){d(),e=n.options.vertical,n.options.disabled||"custom"===n.options.renderMode||(i="auto"===f(n.options.slides,"perView",null),n.on("detailsChanged",a),(t=n.slides).length&&l())}n.on("created",p),n.on("optionsChanged",p),n.on("beforeOptionsChanged",(function(){d()})),n.on("updated",l),n.on("destroyed",d)}function M(n,t){return function(e){var i,o,u,s,d,p,v=c();function h(n){var t;r(e.container,"reverse","rtl"!==(t=e.container,window.getComputedStyle(t,null).getPropertyValue("direction"))||n?null:""),r(e.container,"v",e.options.vertical&&!n?"":null),r(e.container,"disabled",e.options.disabled&&!n?"":null)}function g(){b()&&M()}function b(){var n=null;if(s.forEach((function(t){t.matches&&(n=t.__media)})),n===i)return!1;i||e.emit("beforeOptionsChanged"),i=n;var t=n?u.breakpoints[n]:u;return e.options=m(m({},u),t),h(),I(),A(),C(),!0}function y(n){var t=l(n);return(e.options.vertical?t.height:t.width)/e.size||1}function x(){return e.options.trackConfig.length}function w(n){for(var r in i=!1,u=m(m({},t),n),v.purge(),o=e.size,s=[],u.breakpoints||[]){var a=window.matchMedia(r);a.__media=r,s.push(a),v.add(a,"change",g)}v.add(window,"orientationchange",z),v.add(window,"resize",E),b()}function k(n){e.animator.stop();var t=e.track.details;e.track.init(null!=n?n:t?t.abs:0)}function M(n){k(n),e.emit("optionsChanged")}function T(n,t){if(n)return w(n),void M(t);I(),A();var i=x();C(),x()!==i?M(t):k(t),e.emit("updated")}function C(){var n=e.options.slides;if("function"==typeof n)return e.options.trackConfig=n(e.size,e.slides);for(var t=e.slides,i=t.length,r="number"==typeof n?n:f(n,"number",i,!0),a=[],o=f(n,"perView",1,!0),u=f(n,"spacing",0,!0)/e.size||0,c="auto"===o?u:u/o,s=f(n,"origin","auto"),d=0,l=0;l<r;l++){var p="auto"===o?y(t[l]):1/o-u+c,v="center"===s?.5-p/2:"auto"===s?0:s;a.push({origin:v,size:p,spacing:u}),d+=p}if(d+=u*(r-1),"auto"===s&&!e.options.loop&&1!==o){var h=0;a.map((function(n){var t=d-h;return h+=n.size+u,t>=1||(n.origin=1-t-(d>1?0:1-d)),n}))}e.options.trackConfig=a}function E(){I();var n=e.size;e.options.disabled||n===o||(o=n,T())}function z(){E(),setTimeout(E,500),setTimeout(E,2e3)}function I(){var n=l(e.container);e.size=(e.options.vertical?n.height:n.width)||1}function A(){e.slides=a(e.options.selector,e.container)}e.container=(p=a(n,d||document)).length?p[0]:null,e.destroy=function(){v.purge(),e.emit("destroyed"),h(!0)},e.prev=function(){e.moveToIdx(e.track.details.abs-1,!0)},e.next=function(){e.moveToIdx(e.track.details.abs+1,!0)},e.update=T,w(e.options)}}var T=function(n,t,e){try{return function(n,t){var e,i={};return e={emit:function(n){i[n]&&i[n].forEach((function(n){n(e)}));var t=e.options&&e.options[n];t&&t(e)},moveToIdx:function(n,t,i){var r=e.track.idxToDist(n,t);if(r){var a=e.options.defaultAnimation;e.animator.start([{distance:r,duration:f(i||a,"duration",500),easing:f(i||a,"easing",(function(n){return 1+--n*n*n*n*n}))}])}},on:function(n,t,e){void 0===e&&(e=!1),i[n]||(i[n]=[]);var r=i[n].indexOf(t);r>-1?e&&delete i[n][r]:e||i[n].push(t)},options:n},function(){if(e.track=y(e),e.animator=b(e),t)for(var n=0,i=t;n<i.length;n++)(0,i[n])(e);e.track.init(e.options.initial||0),e.emit("created")}(),e}(t,g([M(n,{drag:!0,mode:"snap",renderMode:"precision",rubberband:!0,selector:".keen-slider__slide"}),k,w,x],e||[],!0))}catch(n){console.error(n)}};exports.E=function(t,e){var i=n.useRef(null),r=n.useRef(!1),a=n.useRef(t),o=n.useCallback((function(n){n?(a.current=t,i.current=new T(n,t,e),r.current=!1):(i.current&&i.current.destroy&&i.current.destroy(),i.current=null)}),[]);return n.useEffect((function(){r.current?i.current&&i.current.update(a.current):r.current=!0}),[h(a,t)]),[o,i]};


/***/ }),

/***/ 5407:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/product",
      function () {
        return __webpack_require__(1143);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 3940:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4637);
/* harmony import */ var next_dist_shared_lib_styled_jsx__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1614);
/* harmony import */ var next_dist_shared_lib_styled_jsx__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_dist_shared_lib_styled_jsx__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(125);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1770);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(7448);





function Demobar(param) {
    var _narrow = param.narrow, narrow = _narrow === void 0 ? false : _narrow, noMargin = param.noMargin, copy = param.copy;
    var locale = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)().locale;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("section", {
        style: {
            margin: noMargin ? 0 : "".concat(narrow ? 0 : 24, "px auto 24px")
        },
        className: next_dist_shared_lib_styled_jsx__WEBPACK_IMPORTED_MODULE_1___default().dynamic([
            [
                "7241d4a1ee4dc5d0",
                [
                    narrow ? _constants__WEBPACK_IMPORTED_MODULE_4__/* .NARROW_WIDTH */ .V : _constants__WEBPACK_IMPORTED_MODULE_4__/* .MAX_WIDTH */ .d
                ]
            ]
        ]),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                className: next_dist_shared_lib_styled_jsx__WEBPACK_IMPORTED_MODULE_1___default().dynamic([
                    [
                        "7241d4a1ee4dc5d0",
                        [
                            narrow ? _constants__WEBPACK_IMPORTED_MODULE_4__/* .NARROW_WIDTH */ .V : _constants__WEBPACK_IMPORTED_MODULE_4__/* .MAX_WIDTH */ .d
                        ]
                    ]
                ]),
                children: copy ? copy : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                    children: [
                        "Ready to build a high-impact climate",
                        " ",
                        locale === "en-GB" ? "programme" : "program",
                        "?"
                    ]
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                href: "/demo",
                passHref: true,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                    "data-track-id": "demobar.contact",
                    className: next_dist_shared_lib_styled_jsx__WEBPACK_IMPORTED_MODULE_1___default().dynamic([
                        [
                            "7241d4a1ee4dc5d0",
                            [
                                narrow ? _constants__WEBPACK_IMPORTED_MODULE_4__/* .NARROW_WIDTH */ .V : _constants__WEBPACK_IMPORTED_MODULE_4__/* .MAX_WIDTH */ .d
                            ]
                        ]
                    ]) + " " + "button primary",
                    children: "Request a demo"
                })
            }),
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_dist_shared_lib_styled_jsx__WEBPACK_IMPORTED_MODULE_1___default()), {
                id: "7241d4a1ee4dc5d0",
                dynamic: [
                    narrow ? _constants__WEBPACK_IMPORTED_MODULE_4__/* .NARROW_WIDTH */ .V : _constants__WEBPACK_IMPORTED_MODULE_4__/* .MAX_WIDTH */ .d
                ],
                children: "section.__jsx-style-dynamic-selector{width:100%;max-width:".concat(narrow ? _constants__WEBPACK_IMPORTED_MODULE_4__/* .NARROW_WIDTH */ .V : _constants__WEBPACK_IMPORTED_MODULE_4__/* .MAX_WIDTH */ .d, "px;padding:8px 24px;-webkit-border-radius:16px;-moz-border-radius:16px;border-radius:16px;background-color:#e0f0ff;display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:justify;-webkit-justify-content:space-between;-moz-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;-webkit-flex-wrap:wrap;-ms-flex-wrap:wrap;flex-wrap:wrap}@media(min-width:820px){section.__jsx-style-dynamic-selector{padding:32px 48px}}h2.__jsx-style-dynamic-selector{font-size:24px;color:#294aae;-webkit-box-flex:1;-webkit-flex-grow:1;-moz-box-flex:1;-ms-flex-positive:1;flex-grow:1;margin:16px 32px 16px 0;z-index:0}.button.__jsx-style-dynamic-selector{display:inline-block;font-size:18px;margin-top:16px;margin-bottom:16px}")
            })
        ]
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (Demobar);


/***/ }),

/***/ 5137:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4637);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}

function ArrowLeft(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", _objectSpread({
        width: 11,
        height: 11,
        viewBox: "0 0 11 11",
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        stroke: "white",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, props, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M5.28 1L1 5.5M1 5.5L5.28 10M1 5.5H10"
        })
    }));
}
/* harmony default export */ __webpack_exports__["Z"] = (ArrowLeft);


/***/ }),

/***/ 2072:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4637);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}

function ArrowRight(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", _objectSpread({
        width: 11,
        height: 11,
        viewBox: "0 0 11 11",
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        stroke: "white",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, props, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M5.72 10L10 5.5M10 5.5L5.72 1M10 5.5L1 5.5"
        })
    }));
}
/* harmony default export */ __webpack_exports__["Z"] = (ArrowRight);


/***/ }),

/***/ 447:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4637);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}

function ChevronRight(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", _objectSpread({
        width: "8",
        height: "14",
        viewBox: "0 0 8 14",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": true,
        focusable: false,
        stroke: "#265CFF",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, props, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M1 1L7 7L1 13"
        })
    }));
}
/* harmony default export */ __webpack_exports__["Z"] = (ChevronRight);


/***/ }),

/***/ 2695:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ product_sections; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@17.0.2/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(4637);
;// CONCATENATED MODULE: ./components/icons/set_square.tsx

function SetSquareIcon() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "56",
        height: "56",
        viewBox: "0 0 56 56",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": true,
        focusable: false,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M12 0C5.37258 0 0 5.37258 0 12V44C0 50.6274 5.37258 56 12 56H44C50.6274 56 56 50.6274 56 44V12C56 5.37258 50.6274 0 44 0H12ZM8.93444 44.0512C8.34852 43.4655 8.34831 42.5158 8.93397 41.9298L13.138 37.7276L13.1383 37.7274C13.4312 37.4346 13.9061 37.4347 14.1989 37.7276L16.2544 39.7864C16.5447 40.0762 17.0148 40.0758 17.3046 39.7856C17.5944 39.4954 17.5941 39.0252 17.3038 38.7354L15.2488 36.6768C14.9562 36.384 14.9562 35.9093 15.2488 35.6165L20.6358 30.2295L20.636 30.2293C20.9291 29.9366 21.404 29.9369 21.6967 30.23L23.7494 32.2859C24.0396 32.5756 24.5098 32.5753 24.7996 32.2851C25.0894 31.9949 25.089 31.5247 24.7988 31.2349L22.7463 29.1791C22.4536 28.8863 22.4536 28.4116 22.7463 28.1188L28.1332 22.7318L28.1336 22.7315C28.4266 22.4387 28.9015 22.4388 29.1943 22.7318L31.244 24.785C31.5342 25.0749 32.0044 25.0746 32.2942 24.7844C32.5841 24.4942 32.5838 24.024 32.2936 23.7341L30.2437 21.681C29.951 21.3882 29.951 20.9135 30.2437 20.6207L35.6329 15.2316L35.6332 15.2312C35.9262 14.9385 36.4011 14.9386 36.6939 15.2316L38.7438 17.2847C39.034 17.5745 39.5042 17.5742 39.794 17.2839C40.0838 16.9937 40.0834 16.5235 39.7932 16.2338L37.7434 14.1808C37.4508 13.8879 37.4508 13.4133 37.7434 13.1204L41.9315 8.93236C42.2128 8.65126 42.5942 8.49335 42.9918 8.49335C43.8203 8.49335 44.4918 9.16493 44.4918 9.99335V42.2403C44.4918 43.4829 43.4845 44.4903 42.2418 44.4903H9.99454C9.59694 44.4902 9.21564 44.3322 8.93444 44.0512ZM25.1385 36.3311L36.3272 25.1421C36.4 25.0692 36.4988 25.0283 36.6017 25.0284C36.816 25.0285 36.9895 25.2022 36.9894 25.4165V36.6054V36.6055C36.9894 36.8198 36.8157 36.9935 36.6015 36.9935H25.413C25.3101 36.9935 25.2114 36.9526 25.1386 36.8799C24.9871 36.7284 24.987 36.4827 25.1385 36.3311Z"
        })
    });
}
/* harmony default export */ var set_square = (SetSquareIcon);

;// CONCATENATED MODULE: ./components/icons/power.tsx

function PowerIcon() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "56",
        height: "56",
        viewBox: "0 0 56 56",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": true,
        focusable: false,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M12.0001 0C5.37271 0 0.00012207 5.37258 0.00012207 12V44C0.00012207 50.6274 5.37271 56 12.0001 56H44.0001C50.6275 56 56.0001 50.6274 56.0001 44V12C56.0001 5.37258 50.6275 0 44.0001 0H12.0001ZM26 23.4161V5.41424C26 4.52333 27.0772 4.07716 27.7071 4.70713L30.671 7.67104C32.1216 9.1216 32.7305 11.2127 32.2855 13.2153L30.017 23.4235C31.7738 24.1989 33 25.9563 33 28C33 28.1892 32.9895 28.3758 32.9691 28.5595L48.5599 37.5609C49.3314 38.0063 49.1792 39.1622 48.3187 39.3928L44.2699 40.4777C42.2884 41.0086 40.173 40.4904 38.6612 39.1037L30.9542 32.0344C30.1265 32.6415 29.1051 33 28 33C26.8883 33 25.8614 32.6372 25.0311 32.0235L9.44015 41.025C8.66861 41.4704 7.74364 40.7607 7.97423 39.9001L9.05909 35.8513C9.59004 33.8698 11.0965 32.2969 13.0533 31.6811L23.029 28.5412C23.0098 28.3635 23 28.1829 23 28C23 25.9497 24.2341 24.1876 26 23.4161ZM30.1741 34.6559C29.4897 34.8793 28.759 35.0001 28 35.0001C27.241 35.0001 26.5103 34.8793 25.8259 34.6559L25.0499 50.9525C25.0227 51.5228 25.4778 52.0001 26.0488 52.0001H29.9513C30.5222 52.0001 30.9773 51.5228 30.9501 50.9525L30.1741 34.6559ZM30.5 28C30.5 29.3807 29.3807 30.5 28 30.5C26.6193 30.5 25.5 29.3807 25.5 28C25.5 26.6193 26.6193 25.5 28 25.5C29.3807 25.5 30.5 26.6193 30.5 28Z"
        })
    });
}
/* harmony default export */ var power = (PowerIcon);

;// CONCATENATED MODULE: ./components/icons/offsets.tsx

function OffsetsIcon() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "56",
        height: "56",
        viewBox: "0 0 56 56",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": true,
        focusable: false,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M12 0C5.37258 0 0 5.37258 0 12V44C0 50.6274 5.37258 56 12 56H44C50.6274 56 56 50.6274 56 44V12C56 5.37258 50.6274 0 44 0H12ZM16.3909 15.4776L21.8 29.0003L26.5186 15.5187C26.8239 14.6464 28.0477 14.6195 28.3909 15.4776L33.8 29.0003L38.5186 15.5187C38.8239 14.6464 40.0477 14.6195 40.3909 15.4776L47.9029 34.2575C48.4284 35.5713 47.4609 37.0003 46.0459 37.0003H42V43C42 43.5523 41.5523 44 41 44H39C38.4477 44 38 43.5523 38 43V37.0003H34.0459H33.819H30V43C30 43.5523 29.5523 44 29 44H27C26.4477 44 26 43.5523 26 43V37.0003H22.0459H21.819H18V43C18 43.5523 17.5523 44 17 44H15C14.4477 44 14 43.5523 14 43V37.0003H9.81896C8.44126 37.0003 7.47612 35.64 7.93124 34.3396L14.5186 15.5187C14.8239 14.6464 16.0477 14.6195 16.3909 15.4776Z"
        })
    });
}
/* harmony default export */ var offsets = (OffsetsIcon);

;// CONCATENATED MODULE: ./components/icons/present.tsx

function PresentIcon() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "56",
        height: "56",
        viewBox: "0 0 56 56",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": true,
        focusable: false,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M12 0C5.37258 0 0 5.37258 0 12V44C0 50.6274 5.37258 56 12 56H44C50.6274 56 56 50.6274 56 44V12C56 5.37258 50.6274 0 44 0H12ZM44.5157 37.0156C45.3441 37.0156 46.0157 36.3441 46.0157 35.5156V35.5156C46.0156 34.6871 45.344 34.0156 44.5156 34.0156V16.0156C45.344 16.0156 46.0156 15.3441 46.0156 14.5156C46.0156 13.6872 45.344 13.0156 44.5156 13.0156H29.5156V11.5156C29.5156 10.6872 28.844 10.0156 28.0156 10.0156C27.1872 10.0156 26.5156 10.6872 26.5156 11.5156V13.0156H11.5156C10.6872 13.0156 10.0156 13.6872 10.0156 14.5156C10.0156 15.3441 10.6872 16.0156 11.5156 16.0156V34.0156C10.6872 34.0156 10.0156 34.6872 10.0156 35.5156C10.0156 36.3441 10.6872 37.0156 11.5156 37.0156H26.5156V37.9735L17.522 43.2166C16.8103 43.6355 16.5679 44.549 16.9783 45.2657L16.9872 45.2813C17.3978 45.9864 18.3023 46.2252 19.0075 45.8146L26.5157 41.4377V44.5156C26.5157 45.3441 27.1872 46.0156 28.0157 46.0156C28.8441 46.0156 29.5157 45.3441 29.5157 44.5156V41.4376L37.0236 45.8146L37.0392 45.8236C37.7493 46.2256 38.6508 45.9758 39.0528 45.2657C39.4633 44.549 39.2209 43.6355 38.5091 43.2166L29.5157 37.9735V37.0156H44.5157ZM23.851 18.3448L35.851 24.3448L35.8511 24.3449C35.9963 24.4174 36.1141 24.5352 36.1867 24.6804C36.3719 25.0509 36.2216 25.5014 35.8511 25.6866L23.8511 31.6866C23.7469 31.7387 23.6321 31.7658 23.5156 31.7658C23.1014 31.7658 22.7656 31.4301 22.7656 31.0158V31.0157V19.0157C22.7656 18.8992 22.7927 18.7844 22.8448 18.6802C23.03 18.3097 23.4805 18.1595 23.851 18.3448Z"
        })
    });
}
/* harmony default export */ var present = (PresentIcon);

;// CONCATENATED MODULE: ./components/product/sections.ts




var sections = {
    measure: {
        title: "Measure",
        colorPrimary: "#0AA9E4",
        icon: set_square
    },
    reduce: {
        title: "Reduce",
        colorPrimary: "#48AF54",
        icon: power
    },
    remove: {
        title: "Remove",
        colorPrimary: "#FAC31D",
        icon: offsets
    },
    report: {
        title: "Report",
        colorPrimary: "#FF8D73",
        icon: present
    }
};
/* harmony default export */ var product_sections = (sections);


/***/ }),

/***/ 1143:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ ProductPage; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@17.0.2/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(4637);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.1.7-canary.31_react-dom@17.0.2+react@17.0.2/node_modules/next/dist/shared/lib/styled-jsx.js
var styled_jsx = __webpack_require__(1614);
var styled_jsx_default = /*#__PURE__*/__webpack_require__.n(styled_jsx);
// EXTERNAL MODULE: ./components/meta.tsx
var meta = __webpack_require__(1797);
// EXTERNAL MODULE: ./components/navbar.tsx + 1 modules
var navbar = __webpack_require__(9106);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.1.7-canary.31_react-dom@17.0.2+react@17.0.2/node_modules/next/link.js
var next_link = __webpack_require__(125);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.1.7-canary.31_react-dom@17.0.2+react@17.0.2/node_modules/next/image.js
var next_image = __webpack_require__(6089);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./components/footer.tsx
var footer = __webpack_require__(4898);
// EXTERNAL MODULE: ./node_modules/.pnpm/next-localization@0.12.0_react@17.0.2/node_modules/next-localization/dist/index.modern.js + 2 modules
var index_modern = __webpack_require__(351);
;// CONCATENATED MODULE: ./public/img/product/hero.webp
/* harmony default export */ var hero = ({"src":"/_next/static/media/hero.e43f2ac7.webp","height":960,"width":2928,"blurDataURL":"data:image/webp;base64,UklGRoAAAABXRUJQVlA4WAoAAAAQAAAABwAAAgAAQUxQSBkAAAAAAAAFEzVlQgoGeMzz9+KwIqb///////+eAFZQOCBAAAAAsAEAnQEqCAADAAJAOCUAToAekP9tgAD+6jiOLv4I+QvsOWH52588G3Jw5bpGPbuYOFKuw5lRVFeNtw3mT94AAA=="});
;// CONCATENATED MODULE: ./public/img/product/drilldown.png
/* harmony default export */ var drilldown = ({"src":"/_next/static/media/drilldown.3334a92c.png","height":1608,"width":2756,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAECAMAAACEE47CAAAAD1BMVEX4+Pjv7+719fXj5ubU3NzE93p6AAAACXBIWXMAABYlAAAWJQFJUiTwAAAAIUlEQVQImRXGsQ0AAAzCsBD4/+aqnsyqSUoL2UbkSX7qAQRRADRgf7xcAAAAAElFTkSuQmCC"});
;// CONCATENATED MODULE: ./public/img/product/reductions.png
/* harmony default export */ var reductions = ({"src":"/_next/static/media/reductions.51ed45b7.png","height":1394,"width":3577,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAADCAMAAACZFr56AAAAFVBMVEXx8e/29/jm5ufv7OHj4MvR2cTg1K7RZDh7AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAHklEQVQImRXBgQ0AIAwDINZO/z/ZCMJ8gnavGLrnAQG5AClPtC/qAAAAAElFTkSuQmCC"});
;// CONCATENATED MODULE: ./components/product/testimonial.tsx




var LOGO_SIZE = 72;
function Testimonial(param) {
    var href = param.href, logo = param.logo, logoAlt = param.logoAlt, quote = param.quote, name = param.name, credential = param.credential;
    var shouldOpenInNewTab = !(href === null || href === void 0 ? void 0 : href.startsWith("/"));
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: styled_jsx_default().dynamic([
            [
                "fe9df6bea0228e26",
                [
                    LOGO_SIZE / 2,
                    LOGO_SIZE,
                    LOGO_SIZE / 3,
                    LOGO_SIZE / 4,
                    LOGO_SIZE,
                    LOGO_SIZE * (2 / 3)
                ]
            ]
        ]) + " " + "testimonial",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                href: href,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                    target: shouldOpenInNewTab ? "_blank" : "",
                    rel: shouldOpenInNewTab ? "noopener noreferrer" : "",
                    className: styled_jsx_default().dynamic([
                        [
                            "fe9df6bea0228e26",
                            [
                                LOGO_SIZE / 2,
                                LOGO_SIZE,
                                LOGO_SIZE / 3,
                                LOGO_SIZE / 4,
                                LOGO_SIZE,
                                LOGO_SIZE * (2 / 3)
                            ]
                        ]
                    ]) + " " + "padded-box featured-customer",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            src: logo,
                            alt: logoAlt,
                            width: LOGO_SIZE,
                            height: LOGO_SIZE,
                            objectFit: "contain",
                            objectPosition: "left center",
                            draggable: "false",
                            className: "logo"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("blockquote", {
                            className: styled_jsx_default().dynamic([
                                [
                                    "fe9df6bea0228e26",
                                    [
                                        LOGO_SIZE / 2,
                                        LOGO_SIZE,
                                        LOGO_SIZE / 3,
                                        LOGO_SIZE / 4,
                                        LOGO_SIZE,
                                        LOGO_SIZE * (2 / 3)
                                    ]
                                ]
                            ]),
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: styled_jsx_default().dynamic([
                                        [
                                            "fe9df6bea0228e26",
                                            [
                                                LOGO_SIZE / 2,
                                                LOGO_SIZE,
                                                LOGO_SIZE / 3,
                                                LOGO_SIZE / 4,
                                                LOGO_SIZE,
                                                LOGO_SIZE * (2 / 3)
                                            ]
                                        ]
                                    ]),
                                    children: quote
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("cite", {
                                    className: styled_jsx_default().dynamic([
                                        [
                                            "fe9df6bea0228e26",
                                            [
                                                LOGO_SIZE / 2,
                                                LOGO_SIZE,
                                                LOGO_SIZE / 3,
                                                LOGO_SIZE / 4,
                                                LOGO_SIZE,
                                                LOGO_SIZE * (2 / 3)
                                            ]
                                        ]
                                    ]),
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                            className: styled_jsx_default().dynamic([
                                                [
                                                    "fe9df6bea0228e26",
                                                    [
                                                        LOGO_SIZE / 2,
                                                        LOGO_SIZE,
                                                        LOGO_SIZE / 3,
                                                        LOGO_SIZE / 4,
                                                        LOGO_SIZE,
                                                        LOGO_SIZE * (2 / 3)
                                                    ]
                                                ]
                                            ]) + " " + "customer-name",
                                            children: [
                                                name,
                                                ", "
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: styled_jsx_default().dynamic([
                                                [
                                                    "fe9df6bea0228e26",
                                                    [
                                                        LOGO_SIZE / 2,
                                                        LOGO_SIZE,
                                                        LOGO_SIZE / 3,
                                                        LOGO_SIZE / 4,
                                                        LOGO_SIZE,
                                                        LOGO_SIZE * (2 / 3)
                                                    ]
                                                ]
                                            ]) + " " + "customer-credential",
                                            children: credential
                                        }),
                                        href && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: styled_jsx_default().dynamic([
                                                [
                                                    "fe9df6bea0228e26",
                                                    [
                                                        LOGO_SIZE / 2,
                                                        LOGO_SIZE,
                                                        LOGO_SIZE / 3,
                                                        LOGO_SIZE / 4,
                                                        LOGO_SIZE,
                                                        LOGO_SIZE * (2 / 3)
                                                    ]
                                                ]
                                            ]) + " " + "read-more",
                                            children: "Read more \u203A"
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            }),
            (0,jsx_runtime.jsx)((styled_jsx_default()), {
                id: "fe9df6bea0228e26",
                dynamic: [
                    LOGO_SIZE / 2,
                    LOGO_SIZE,
                    LOGO_SIZE / 3,
                    LOGO_SIZE / 4,
                    LOGO_SIZE,
                    LOGO_SIZE * (2 / 3)
                ],
                children: ".featured-customer.__jsx-style-dynamic-selector{max-width:640px;margin-top:".concat(LOGO_SIZE / 2, "px;margin-inline:auto;-webkit-border-radius:var(--module-radius);-moz-border-radius:var(--module-radius);border-radius:var(--module-radius);background-color:var(--module-color);display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-webkit-flex-direction:column;-moz-box-orient:vertical;-moz-box-direction:normal;-ms-flex-direction:column;flex-direction:column;gap:var(--module-gap);text-decoration:none;color:inherit;-webkit-transition:background-color.125s ease-in-out;-moz-transition:background-color.125s ease-in-out;-o-transition:background-color.125s ease-in-out;transition:background-color.125s ease-in-out}.featured-customer.__jsx-style-dynamic-selector:hover,.featured-customer.__jsx-style-dynamic-selector:focus{--module-color:var(--module-color-hover);--module-color-quote:var(--module-color-hover-quote)}.featured-customer.__jsx-style-dynamic-selector>span{margin:-").concat(LOGO_SIZE, "px 0 -").concat(LOGO_SIZE / 3, "px!important}@media screen and (min-width:820px){section.__jsx-style-dynamic-selector{grid-column:-1/1}.featured-customer.__jsx-style-dynamic-selector{margin-top:").concat(LOGO_SIZE / 4, "px;gap:36px;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-webkit-flex-direction:row;-moz-box-orient:horizontal;-moz-box-direction:normal;-ms-flex-direction:row;flex-direction:row;-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center}.featured-customer.__jsx-style-dynamic-selector>span{margin:-").concat(LOGO_SIZE, "px 0 0 -").concat(LOGO_SIZE * (2 / 3), 'px!important;-webkit-transform:scale(1.25);-moz-transform:scale(1.25);-ms-transform:scale(1.25);-o-transform:scale(1.25);transform:scale(1.25)}blockquote.__jsx-style-dynamic-selector p.__jsx-style-dynamic-selector::before{left:-24px}cite.__jsx-style-dynamic-selector .read-more.__jsx-style-dynamic-selector{margin-left:auto}}blockquote.__jsx-style-dynamic-selector{line-height:1.5;margin:0;position:relative;-webkit-box-flex:1;-webkit-flex-grow:1;-moz-box-flex:1;-ms-flex-positive:1;flex-grow:1}blockquote.__jsx-style-dynamic-selector p.__jsx-style-dynamic-selector{position:relative}blockquote.__jsx-style-dynamic-selector p.__jsx-style-dynamic-selector::before,blockquote.__jsx-style-dynamic-selector p.__jsx-style-dynamic-selector::after{color:var(--module-color-quote);-webkit-transition:color.125s ease-in-out;-moz-transition:color.125s ease-in-out;-o-transition:color.125s ease-in-out;transition:color.125s ease-in-out;font-size:48px;line-height:16px;position:absolute}blockquote.__jsx-style-dynamic-selector p.__jsx-style-dynamic-selector::before{content:"\u201C";left:-20px;top:12px}blockquote.__jsx-style-dynamic-selector p.__jsx-style-dynamic-selector::after{content:"\u201D";bottom:0;padding-left:4px}cite.__jsx-style-dynamic-selector{display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center;color:#6d7384;font-style:normal;white-space:nowrap;-webkit-flex-wrap:wrap;-ms-flex-wrap:wrap;flex-wrap:wrap}cite.__jsx-style-dynamic-selector .customer-name.__jsx-style-dynamic-selector{position:relative;font-weight:bold;padding-right:4px}cite.__jsx-style-dynamic-selector .customer-name.__jsx-style-dynamic-selector::before{content:"\u2014";position:absolute;left:-20px;color:var(--module-color-quote)}cite.__jsx-style-dynamic-selector .customer-credential.__jsx-style-dynamic-selector{-webkit-box-flex:1;-webkit-flex-grow:1;-moz-box-flex:1;-ms-flex-positive:1;flex-grow:1;margin-right:8px}cite.__jsx-style-dynamic-selector .read-more.__jsx-style-dynamic-selector{color:#265cff;font-weight:bold}')
            })
        ]
    });
};

;// CONCATENATED MODULE: ./public/img/testimonials/shopify.svg
/* harmony default export */ var shopify = ({"src":"/_next/static/media/shopify.b379e058.svg","height":2500,"width":2192});
;// CONCATENATED MODULE: ./public/img/testimonials/block.png
/* harmony default export */ var block = ({"src":"/_next/static/media/block.79f6264a.png","height":600,"width":600,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAflBMVEVMaXFpr5jDXU0ox7aRuWm/07qpdGboeFuvdkzZfWnovZe+ZFya4e3RODX//f/vzLp1u6Ph58rjwr1hxbjz+dj+o5l2qq7YsJiqzMDn/PH0XkO1o4XbnKuzgZ3urJvx69KuqrGIuaTqtqqGqJZky7Tp9vlNuaTq3di8g31lusXIYTLlAAAAIHRSTlMAo9pOCP41/F0Tc7hj5Vhe64/gUT1I+P7+dv76/PpToFUWH70AAAAJcEhZcwAACxMAAAsTAQCanBgAAABHSURBVAiZFctHAkAwAADBRYjee43o//8gTnMagC4TAOVy6TyBStv2pI6YWcqmrZ+QYpX9qDYXa1+HOzJdhJ+egfcvPMP5eAGXgQPpOWtLJAAAAABJRU5ErkJggg=="});
// EXTERNAL MODULE: ./components/product/sections.ts + 4 modules
var sections = __webpack_require__(2695);
;// CONCATENATED MODULE: ./components/product/section/intro.tsx


function SectionIntro(param) {
    var title = param.title, headline = param.headline, colorPrimary = param.colorPrimary, _colorAccent = param.colorAccent, colorAccent = _colorAccent === void 0 ? "hsl(48deg 100% 67%)" : _colorAccent, _colorText = param.colorText, colorText = _colorText === void 0 ? "#fff" : _colorText, Icon = param.icon;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("header", {
        style: {
            // @ts-expect-error TS balks at custom properties
            "--colors-header-primary": colorPrimary,
            "--colors-header-text": colorText,
            "--colors-header-accent": colorAccent
        },
        className: "jsx-8ad68faa616a4134",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "jsx-8ad68faa616a4134" + " " + "container",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon, {
                        className: "jsx-8ad68faa616a4134"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                        className: "jsx-8ad68faa616a4134" + " " + "word",
                        children: title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                        className: "jsx-8ad68faa616a4134" + " " + "headline",
                        children: headline
                    })
                ]
            }),
            (0,jsx_runtime.jsx)((styled_jsx_default()), {
                id: "8ad68faa616a4134",
                children: "header.jsx-8ad68faa616a4134{background-image:-webkit-linear-gradient(#fff,#f7f7f9);background-image:-moz-linear-gradient(#fff,#f7f7f9);background-image:-o-linear-gradient(#fff,#f7f7f9);background-image:linear-gradient(#fff,#f7f7f9);padding:48px 24px 0}.container.jsx-8ad68faa616a4134{position:relative;display:grid;-webkit-column-gap:16px;-moz-column-gap:16px;column-gap:16px;-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center}.container.jsx-8ad68faa616a4134 svg{fill:var(--colors-header-primary);width:76px;height:76px}.word.jsx-8ad68faa616a4134{--font-size:72px;--border-width:2px;line-height:1.25;font-size:var(--font-size);margin-bottom:0;letter-spacing:-.05em;text-indent:-.04em}.number.jsx-8ad68faa616a4134{color:var(--colors-header-primary);border:6px double currentColor;-webkit-border-radius:16px;-moz-border-radius:16px;border-radius:16px;width:-webkit-calc(var(--font-size)*.875);width:-moz-calc(var(--font-size)*.875);width:calc(var(--font-size)*.875);height:-webkit-calc(var(--font-size)*.875);height:-moz-calc(var(--font-size)*.875);height:calc(var(--font-size)*.875);line-height:1.125;font-size:.625em;display:inline-block;text-align:center}@media(min-width:520px){header.jsx-8ad68faa616a4134{padding:0 24px}section:not(:first-of-type) header.jsx-8ad68faa616a4134{padding-top:48px}.container.jsx-8ad68faa616a4134{grid-template-columns:auto 1fr;-webkit-column-gap:32px;-moz-column-gap:32px;column-gap:32px}.container.jsx-8ad68faa616a4134 svg{width:92px;height:92px}.headline.jsx-8ad68faa616a4134{grid-column:2}.word.jsx-8ad68faa616a4134{--font-size:84px}.number.jsx-8ad68faa616a4134{line-height:1.2}}.headline.jsx-8ad68faa616a4134{color:#494e5a;opacity:.875;margin:0;max-width:none;font-size:24px;letter-spacing:-.03em;z-index:initial}@media(min-width:1250px){header.jsx-8ad68faa616a4134{padding:64px 48px 0}section:not(:first-of-type) header.jsx-8ad68faa616a4134{padding-top:72px}.headline.jsx-8ad68faa616a4134{font-size:42px}.container.jsx-8ad68faa616a4134{padding:0 52px!important}}"
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/product/section/modules.tsx


function SectionModules(param) {
    var colorPrimary = param.colorPrimary, children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("article", {
        style: {
            // @ts-expect-error custom property
            "--section-primary": colorPrimary
        },
        className: "jsx-a04e6c49889b189f" + " " + "modules-container",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "jsx-a04e6c49889b189f" + " " + "modules container",
                children: children
            }),
            (0,jsx_runtime.jsx)((styled_jsx_default()), {
                id: "a04e6c49889b189f",
                children: ".modules-container.jsx-a04e6c49889b189f{--module-color:#fff;background-color:#f7f7f9;padding-bottom:24px}.modules.jsx-a04e6c49889b189f{display:grid;gap:var(--module-gap)}@media screen and (min-width:820px){.modules.jsx-a04e6c49889b189f{grid-template-columns:repeat(2,minmax(0,1fr))}}@media(min-width:1250px){.modules-container.jsx-a04e6c49889b189f{padding-top:var(--module-gap);padding-bottom:-webkit-calc(3*var(--module-gap));padding-bottom:-moz-calc(3*var(--module-gap));padding-bottom:calc(3*var(--module-gap))}.modules.jsx-a04e6c49889b189f{gap:40px var(--module-gap)}}.modules.jsx-a04e6c49889b189f p.jsx-a04e6c49889b189f a{font-weight:bold}"
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/product/section/index.tsx
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}




function Section(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        "data-track-id": "product.section-".concat(props.title.toLowerCase()),
        id: props.title.toLowerCase(),
        className: "jsx-c2208b009740ac6e",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionIntro, _objectSpread({}, props)),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionModules, _objectSpread({}, props, {
                children: props.children
            })),
            (0,jsx_runtime.jsx)((styled_jsx_default()), {
                id: "c2208b009740ac6e",
                children: "section.jsx-c2208b009740ac6e{scroll-margin-top:60px}@media(min-width:520px){section.jsx-c2208b009740ac6e{scroll-margin-top:108px}}"
            })
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/.pnpm/react@17.0.2/node_modules/react/index.js
var react = __webpack_require__(9496);
;// CONCATENATED MODULE: ./components/product/screenshot.tsx
function screenshot_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function screenshot_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            screenshot_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}




function Screenshot(_param) {
    var cropped = _param.cropped, caption = _param.caption, props = _objectWithoutProperties(_param, [
        "cropped",
        "caption"
    ]);
    var ref = (0,react.useState)(false), zoomed = ref[0], setZoomed = ref[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("figure", {
        onClick: function() {
            return setZoomed(function(z) {
                return !z;
            });
        },
        className: "jsx-65f87b380e945101" + " " + ((zoomed ? "is-zoomed" : cropped ? "cropped" : undefined) || ""),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), screenshot_objectSpread({}, props, {
                placeholder: "blur",
                objectFit: "contain",
                objectPosition: "center"
            })),
            caption && /*#__PURE__*/ (0,jsx_runtime.jsx)("figcaption", {
                className: "jsx-65f87b380e945101",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: "jsx-65f87b380e945101",
                    children: caption
                })
            }),
            (0,jsx_runtime.jsx)((styled_jsx_default()), {
                id: "65f87b380e945101",
                children: "figure.jsx-65f87b380e945101{line-height:0;-webkit-align-self:center;-ms-flex-item-align:center;align-self:center;cursor:-webkit-zoom-in;cursor:-moz-zoom-in;cursor:zoom-in}figcaption.jsx-65f87b380e945101{display:none;left:0;bottom:0;right:0;opacity:0;-webkit-transition:.25s opacity ease-in-out;-moz-transition:.25s opacity ease-in-out;-o-transition:.25s opacity ease-in-out;transition:.25s opacity ease-in-out}figcaption.jsx-65f87b380e945101 span.jsx-65f87b380e945101{margin-inline:auto;text-align:center;color:#494e5a;font-weight:bold;display:block}figure.jsx-65f87b380e945101 img{-webkit-border-radius:8px;-moz-border-radius:8px;border-radius:8px;border:1px solid rgba(0,0,0,.0625)!important}figure.is-zoomed.jsx-65f87b380e945101{position:fixed;z-index:9999;inset:0;display:grid;grid-template-rows:1fr auto;-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-webkit-justify-content:center;-moz-box-pack:center;-ms-flex-pack:center;justify-content:center;gap:max(24px,5vh);background-color:rgba(255,255,255,.75);cursor:-webkit-zoom-out;cursor:-moz-zoom-out;cursor:zoom-out;max-width:100vw!important;max-height:100vh!important;padding:clamp(16px,10vh,32px)max(24px,4vw)clamp(16px,10vh,32px)}figure.is-zoomed.jsx-65f87b380e945101>span{max-height:100%;-webkit-filter:drop-shadow(0px 30px 60px rgba(50,50,93,.25))drop-shadow(0px 18px 36px rgba(0,0,0,.3))!important;filter:drop-shadow(0px 30px 60px rgba(50,50,93,.25))drop-shadow(0px 18px 36px rgba(0,0,0,.3))!important}figure.is-zoomed.jsx-65f87b380e945101 img{border:0!important}@supports(backdrop-filter:saturate(180%)blur(8px))or (-webkit-backdrop-filter:saturate(180%)blur(8px)){figure.is-zoomed.jsx-65f87b380e945101{-webkit-backdrop-filter:saturate(180%)blur(8px);backdrop-filter:saturate(180%)blur(8px)}}@media(min-width:520px){figure.jsx-65f87b380e945101{padding:24px}}@media(min-width:820px){figure.jsx-65f87b380e945101 img{-webkit-border-radius:16px;-moz-border-radius:16px;border-radius:16px;border:1px solid rgba(0,0,0,.0625)!important}figure.is-zoomed.jsx-65f87b380e945101 figcaption.jsx-65f87b380e945101{display:block;opacity:1}}figure.cropped.jsx-65f87b380e945101{padding-bottom:0}figure.cropped.jsx-65f87b380e945101 img{-webkit-border-bottom-left-radius:0;-moz-border-radius-bottomleft:0;border-bottom-left-radius:0;-webkit-border-bottom-right-radius:0;-moz-border-radius-bottomright:0;border-bottom-right-radius:0;border-bottom:0!important}"
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/module.tsx


function ModuleColumn(param) {
    var headline = param.headline, children = param.children, graphic = param.graphic, _doubleWidth = param.doubleWidth, doubleWidth = _doubleWidth === void 0 ? false : _doubleWidth, _doubleHeight = param.doubleHeight, doubleHeight = _doubleHeight === void 0 ? false : _doubleHeight, id = param.id, className = param.className;
    var layoutClassName = doubleWidth ? "double-width" : doubleHeight ? "double-height" : undefined;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        id: id,
        className: "jsx-5b22d52f27880320" + " " + ([
            layoutClassName,
            className
        ].filter(Boolean).join(" ") || ""),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                style: graphic ? {
                    paddingBottom: 16
                } : undefined,
                className: "jsx-5b22d52f27880320" + " " + "padded-box",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                        className: "jsx-5b22d52f27880320",
                        children: headline
                    }),
                    children
                ]
            }),
            graphic,
            (0,jsx_runtime.jsx)((styled_jsx_default()), {
                id: "5b22d52f27880320",
                children: "section.jsx-5b22d52f27880320{-webkit-border-radius:var(--module-radius);-moz-border-radius:var(--module-radius);border-radius:var(--module-radius);background-color:var(--module-color);display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-webkit-flex-direction:column;-moz-box-orient:vertical;-moz-box-direction:normal;-ms-flex-direction:column;flex-direction:column;max-width:-webkit-calc(100vw - 24px);max-width:-moz-calc(100vw - 24px);max-width:calc(100vw - 24px);overflow:hidden;scroll-margin-top:72px}.padded-box.jsx-5b22d52f27880320 p{max-width:64ch}.padded-box.jsx-5b22d52f27880320 p:last-of-type{margin-bottom:0}@media(min-width:820px){section.jsx-5b22d52f27880320{scroll-margin-top:140px}.double-width.jsx-5b22d52f27880320{grid-column:span 2}.double-height.jsx-5b22d52f27880320{grid-row:span 2}}"
            })
        ]
    });
}
function ModuleTwoUp(param) {
    var headline = param.headline, children = param.children, graphic = param.graphic, id = param.id, className = param.className;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        id: id,
        className: "jsx-15dd8610cc0c8357" + " " + (className || ""),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "jsx-15dd8610cc0c8357" + " " + "padded-box",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                        className: "jsx-15dd8610cc0c8357",
                        children: headline
                    }),
                    children
                ]
            }),
            graphic,
            (0,jsx_runtime.jsx)((styled_jsx_default()), {
                id: "15dd8610cc0c8357",
                children: "section.jsx-15dd8610cc0c8357{display:grid;-webkit-border-radius:var(--module-radius);-moz-border-radius:var(--module-radius);border-radius:var(--module-radius);background-color:var(--module-color);overflow:hidden;scroll-margin-top:72px}@media(min-width:820px){section.jsx-15dd8610cc0c8357{grid-column:span 2;grid-template-columns:repeat(2,minmax(0,1fr));scroll-margin-top:140px}}"
            })
        ]
    });
}

;// CONCATENATED MODULE: ./public/img/marketplace/solar.jpg
/* harmony default export */ var solar = ({"src":"/_next/static/media/solar.d302f04f.jpg","height":563,"width":1000,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAAEAAgDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAX/xAAbEAACAgMBAAAAAAAAAAAAAAAAAQIRAwQFIf/EABQBAQAAAAAAAAAAAAAAAAAAAAP/xAAXEQADAQAAAAAAAAAAAAAAAAAAAQJR/9oADAMBAAIRAxEAPwCLLs9JwcnuZG7r2gAMonA3d6f/2Q=="});
;// CONCATENATED MODULE: ./components/product/modules/clean_energy.tsx







function CleanEnergyModule() {
    var t = (0,index_modern/* useI18n */.QT)().t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ModuleColumn, {
        graphic: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
            src: solar,
            alt: "Illustration of solar farm",
            placeholder: "blur"
        }),
        headline: "".concat(t("common.Decarbonize"), " your power"),
        className: "module-clean-energy",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                className: "jsx-73b5fb1b2fb89808",
                children: [
                    "Use Watershed to buy",
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: "/blog/clean-power-how-companies-decarbonize-electricity",
                        children: "clean power"
                    }),
                    " ",
                    "for your buildings, data centers, and remote workers. We vet projects to ensure impact, and help you match purchases with your local electricity grids."
                ]
            }),
            (0,jsx_runtime.jsx)((styled_jsx_default()), {
                id: "73b5fb1b2fb89808",
                children: "section.module-clean-energy{background-color:#e87154}.module-clean-energy h3,.module-clean-energy a{color:#fff}.module-clean-energy p{color:#fdf3d8}"
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/product/modules/csm.tsx


function CSMModule() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: "jsx-99f092d71d9f435a" + " " + "padded-box",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "jsx-99f092d71d9f435a" + " " + "eyebrow",
                children: "Climate Expertise"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                className: "jsx-99f092d71d9f435a",
                children: "Receive hands-on support every step of the way, without the need for consultants"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "jsx-99f092d71d9f435a" + " " + "intro",
                children: "Work directly with our in-house climate leads, who bring expertise from McKinsey, Stanford, Apple, and other prestigious climate programs."
            }),
            (0,jsx_runtime.jsx)((styled_jsx_default()), {
                id: "99f092d71d9f435a",
                children: "section.jsx-99f092d71d9f435a{-webkit-align-self:center;-ms-flex-item-align:center;align-self:center}p.eyebrow.jsx-99f092d71d9f435a{color:#4f9a90;font-weight:bold}p.intro.jsx-99f092d71d9f435a{color:#263245;font-size:21px;line-height:32px}"
            })
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/.pnpm/keen-slider@6.6.14/node_modules/keen-slider/react.js
var keen_slider_react = __webpack_require__(8720);
// EXTERNAL MODULE: ./components/icons/arrow_left.tsx
var arrow_left = __webpack_require__(5137);
// EXTERNAL MODULE: ./components/icons/arrow_right.tsx
var arrow_right = __webpack_require__(2072);
;// CONCATENATED MODULE: ./public/img/marketplace/biochar.jpg
/* harmony default export */ var biochar = ({"src":"/_next/static/media/biochar.88452794.jpg","height":563,"width":1000,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAAEAAgDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAb/xAAaEAACAgMAAAAAAAAAAAAAAAAAEgMUBBNR/8QAFQEBAQAAAAAAAAAAAAAAAAAAAwT/xAAYEQACAwAAAAAAAAAAAAAAAAAAAQITQf/aAAwDAQACEQMRAD8Ahb+a+y5M3XAA5PXB4j//2Q=="});
;// CONCATENATED MODULE: ./public/img/marketplace/biooil.jpg
/* harmony default export */ var biooil = ({"src":"/_next/static/media/biooil.092b11ae.jpg","height":563,"width":1000,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAAEAAgDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAT/xAAdEAACAgIDAQAAAAAAAAAAAAACAwABBREEEiFR/8QAFQEBAQAAAAAAAAAAAAAAAAAAAgT/xAAYEQEBAAMAAAAAAAAAAAAAAAABAAIRIf/aAAwDAQACEQMRAD8AqLOc9eUXlQddPaZqMd30sRbqvN/PIiIMg5Tqi6v/2Q=="});
;// CONCATENATED MODULE: ./public/img/marketplace/concrete.jpg
/* harmony default export */ var concrete = ({"src":"/_next/static/media/concrete.77fd326e.jpg","height":563,"width":1000,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAAEAAgDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAL/xAAfEAABAwMFAAAAAAAAAAAAAAACAAEDBAUhERMxUWH/xAAVAQEBAAAAAAAAAAAAAAAAAAADBP/EABgRAAIDAAAAAAAAAAAAAAAAAAABAxJB/9oADAMBAAIRAxEAPwC4AErNVXOQdyWnB3jA8gOOuXbx30RESaTxpVP/2Q=="});
;// CONCATENATED MODULE: ./public/img/marketplace/dac.jpg
/* harmony default export */ var dac = ({"src":"/_next/static/media/dac.f987b040.jpg","height":563,"width":1000,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAAEAAgDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAT/xAAdEAABBAIDAAAAAAAAAAAAAAAABRESEwEUAyEx/8QAFAEBAAAAAAAAAAAAAAAAAAAAA//EABYRAQEBAAAAAAAAAAAAAAAAAAACEf/aAAwDAQACEQMRAD8AtysqW1TucldkY9eOzAATAS//2Q=="});
;// CONCATENATED MODULE: ./public/img/marketplace/kelp.jpg
/* harmony default export */ var kelp = ({"src":"/_next/static/media/kelp.99823650.jpg","height":563,"width":1000,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAAEAAgDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAT/xAAbEAACAgMBAAAAAAAAAAAAAAAAAwIRAQQikv/EABUBAQEAAAAAAAAAAAAAAAAAAAMF/8QAFhEBAQEAAAAAAAAAAAAAAAAAAQAh/9oADAMBAAIRAxEAPwCHbYyTlXPPEU16AArQFwv/2Q=="});
;// CONCATENATED MODULE: ./public/img/marketplace/ocean.jpg
/* harmony default export */ var ocean = ({"src":"/_next/static/media/ocean.244d2042.jpg","height":563,"width":1000,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAAEAAgDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAT/xAAeEAABBAEFAAAAAAAAAAAAAAABAAIEEwUGERIxUf/EABUBAQEAAAAAAAAAAAAAAAAAAAME/8QAGxEAAgEFAAAAAAAAAAAAAAAAAAETAgNCUpH/2gAMAwEAAhEDEQA/AJGauyhivjmitruQFQ793REVEVGqCmurJ9P/2Q=="});
;// CONCATENATED MODULE: ./public/img/marketplace/olivine.jpg
/* harmony default export */ var olivine = ({"src":"/_next/static/media/olivine.820563ae.jpg","height":563,"width":1000,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAAEAAgDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAT/xAAcEAACAgIDAAAAAAAAAAAAAAABAgAEBSEDEXH/xAAVAQEBAAAAAAAAAAAAAAAAAAACBP/EABgRAAIDAAAAAAAAAAAAAAAAAAABAhEx/9oADAMBAAIRAxEAPwCvDXnxyGvWRV42OwWc9eb1ERJrYI4f/9k="});
;// CONCATENATED MODULE: ./components/home/marketplace_gallery.tsx
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function marketplace_gallery_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : (typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]);
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function marketplace_gallery_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            marketplace_gallery_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}














var marketplace_gallery_images = [
    {
        src: kelp,
        alt: "Kelp farming carbon removal"
    },
    {
        src: dac,
        alt: "Direct air carbon capture"
    },
    {
        src: biooil,
        alt: "Bio-oil sequestration"
    },
    {
        src: olivine,
        alt: "Olivine weathering carbon capture"
    },
    {
        src: ocean,
        alt: "Ocean mineralization sequestration"
    },
    {
        src: biochar,
        alt: "Biochar carbon removal"
    },
    {
        src: concrete,
        alt: "Mineralization in concrete"
    }, 
];
var MarketplaceGallery = function(param) {
    var style = param.style;
    var ref4 = (0,react.useState)(false), isMounted = ref4[0], setIsMounted = ref4[1];
    var ref1 = (0,react.useState)(false), pause = ref1[0], setPause = ref1[1];
    var ref2 = _slicedToArray((0,keen_slider_react/* useKeenSlider */.E)({
        loop: true,
        defaultAnimation: {
            duration: 1000
        },
        slides: {
            perView: 1
        },
        created: function() {
            return setIsMounted(true);
        },
        dragStarted: function() {
            setPause(true);
        },
        dragEnded: function() {
            setPause(false);
        }
    }), 2), ref3 = ref2[0], slider = ref2[1];
    var onPrev = (0,react.useCallback)(function() {
        var ref;
        return (ref = slider.current) === null || ref === void 0 ? void 0 : ref.prev();
    }, [
        slider
    ]);
    var onNext = (0,react.useCallback)(function() {
        var ref;
        return (ref = slider.current) === null || ref === void 0 ? void 0 : ref.next();
    }, [
        slider
    ]);
    (0,react.useEffect)(function() {
        var timer = setInterval(function() {
            if (!pause && slider) {
                onNext();
            }
        }, 4000);
        return function() {
            clearInterval(timer);
        };
    }, [
        pause,
        slider,
        onNext
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        onMouseOver: function() {
            return setPause(true);
        },
        onMouseOut: function() {
            return setPause(false);
        },
        style: marketplace_gallery_objectSpread({
            opacity: isMounted ? 1 : 0,
            width: "min(100vw - 24px, 520px)"
        }, style),
        className: "jsx-d8683a8083b76881" + " " + "gallery",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                ref: ref3,
                className: "jsx-d8683a8083b76881" + " " + "keen-slider",
                children: marketplace_gallery_images.map(function(img) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("figure", {
                        className: "jsx-d8683a8083b76881" + " " + "keen-slider__slide",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                src: img.src,
                                alt: img.alt,
                                placeholder: "blur",
                                objectFit: "cover"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("figcaption", {
                                className: "jsx-d8683a8083b76881" + " " + "caption",
                                children: img.alt
                            })
                        ]
                    }, img.alt);
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                onClick: onPrev,
                "aria-label": "Previous Image",
                className: "jsx-d8683a8083b76881",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(arrow_left/* default */.Z, {
                    "aria-hidden": true
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                onClick: onNext,
                "aria-label": "Next Image",
                className: "jsx-d8683a8083b76881",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(arrow_right/* default */.Z, {
                    "aria-hidden": true
                })
            }),
            (0,jsx_runtime.jsx)((styled_jsx_default()), {
                id: "d8683a8083b76881",
                children: ".gallery.jsx-d8683a8083b76881{position:relative;height:100%;max-width:100%;-webkit-border-radius:16px;-moz-border-radius:16px;border-radius:16px;z-index:1;overflow:hidden;line-height:0}.keen-slider.jsx-d8683a8083b76881{min-width:0px;height:100%;width:100%;display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-align:stretch;-webkit-align-items:stretch;-moz-box-align:stretch;-ms-flex-align:stretch;align-items:stretch;-webkit-border-radius:16px;-moz-border-radius:16px;border-radius:16px;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;-ms-touch-action:-ms-pan-y;-ms-touch-action:pan-y;touch-action:pan-y;-webkit-transition:opacity.125s ease-in-out;-moz-transition:opacity.125s ease-in-out;-o-transition:opacity.125s ease-in-out;transition:opacity.125s ease-in-out}.keen-slider__slide.jsx-d8683a8083b76881{display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-webkit-flex-direction:column;-moz-box-orient:vertical;-moz-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-align:end;-webkit-align-items:flex-end;-moz-box-align:end;-ms-flex-align:end;align-items:flex-end;-webkit-flex-shrink:0;-ms-flex-negative:0;flex-shrink:0;max-height:100%;-webkit-border-radius:16px;-moz-border-radius:16px;border-radius:16px}.keen-slider__slide.jsx-d8683a8083b76881>span{-webkit-box-flex:1;-webkit-flex:1 1 auto;-moz-box-flex:1;-ms-flex:1 1 auto;flex:1 1 auto}.caption.jsx-d8683a8083b76881{background-color:var(--module-color-hover);width:100%;padding:16px 32px;text-align:center;font-weight:bold;bottom:0;left:0;right:0;margin:0;line-height:1;-webkit-border-radius:0 0 16px 16px;-moz-border-radius:0 0 16px 16px;border-radius:0 0 16px 16px}button.jsx-d8683a8083b76881{-webkit-appearance:none;border:0;background-color:var(--module-color-hover-quote);-webkit-border-radius:99999px;-moz-border-radius:99999px;border-radius:99999px;cursor:pointer;padding:10px;width:32px;height:32px;bottom:8px;position:absolute}button.jsx-d8683a8083b76881:first-of-type{left:8px}button.jsx-d8683a8083b76881:last-of-type{right:8px}"
            })
        ]
    });
};
/* harmony default export */ var marketplace_gallery = (MarketplaceGallery);

;// CONCATENATED MODULE: ./components/icons/circle_checkmark.tsx

function CircleCheckmarkIcon() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "56",
        height: "56",
        viewBox: "0 0 56 56",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": true,
        focusable: false,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M12 0C5.37258 0 0 5.37258 0 12V44C0 50.6274 5.37258 56 12 56H44C50.6274 56 56 50.6274 56 44V12C56 5.37258 50.6274 0 44 0H12ZM13.0062 28.013C13.0062 36.2973 19.722 43.013 28.0062 43.013C36.2905 43.013 43.0062 36.2973 43.0062 28.013C43.0062 19.7288 36.2905 13.013 28.0062 13.013C19.722 13.013 13.0062 19.7288 13.0062 28.013ZM34.6124 20.8857C35.0983 20.3947 35.8902 20.3905 36.3812 20.8764C36.8159 21.3334 36.861 22.036 36.4884 22.5448L27.9923 34.7101C27.8658 34.891 27.7086 35.0483 27.5277 35.1748C26.6749 35.7708 25.5005 35.5628 24.9044 34.7101L20.7641 28.782C20.3912 28.2731 20.4363 27.5703 20.8711 27.1132C20.9219 27.063 20.9768 27.0172 21.0354 26.9764C21.6019 26.5812 22.3816 26.7202 22.7768 27.2868L26.4482 32.5438L34.4756 21.05C34.5165 20.9914 34.5622 20.9365 34.6124 20.8857Z"
        })
    });
}
/* harmony default export */ var circle_checkmark = (CircleCheckmarkIcon);

;// CONCATENATED MODULE: ./components/icons/microscope.tsx

function MicroscropeIcon() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "56",
        height: "56",
        viewBox: "0 0 56 56",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": true,
        focusable: false,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M12 0C5.37258 0 0 5.37258 0 12V44C0 50.6274 5.37258 56 12 56H44C50.6274 56 56 50.6274 56 44V12C56 5.37258 50.6274 0 44 0H12ZM16.1174 44.248H37.3688C37.5628 44.248 37.7543 44.2028 37.9279 44.1161C38.5454 43.8074 38.7957 43.0565 38.487 42.439L35.6819 36.8307C35.5787 36.6212 35.6013 36.3716 35.7404 36.1839C35.8957 35.9702 36.0439 35.7514 36.1846 35.5277C39.6571 30.0077 37.9972 22.7179 32.4772 19.2454L32.5916 18.934L32.5956 18.9228C32.8234 18.2782 32.4854 17.571 31.8408 17.3433L34.1961 10.9313L34.1974 10.9275C34.3137 10.6041 34.1458 10.2476 33.8223 10.1313L31.4639 9.28336C31.1377 9.16766 30.7791 9.33508 30.6583 9.65943L28.3032 16.0716C27.6543 15.8364 26.937 16.1678 26.6954 16.8144L23.0532 26.7311L23.0489 26.7428C22.8214 27.3873 23.1594 28.0942 23.8039 28.3217L23.1611 30.0717L23.1596 30.0759C23.0443 30.3967 23.2109 30.7502 23.5317 30.8655L25.8995 31.7168C26.2232 31.8332 26.5801 31.6666 26.6987 31.3437L27.3415 29.5937C27.9904 29.829 28.7077 29.4976 28.9493 28.851L30.1768 25.5088L33.2677 26.6334C33.6726 26.7799 33.974 27.124 34.0659 27.5447C34.4605 29.3778 34.2058 31.2911 33.3454 32.9572C32.9125 33.7618 32.0685 34.2594 31.1549 34.2486H18.6181C18.2776 34.2477 17.9995 34.52 17.9931 34.8604C17.9871 35.5999 18.4885 36.2473 19.206 36.4266L25.0214 37.88C25.2996 37.9496 25.4948 38.1995 25.4948 38.4863V39.3853C25.4947 39.6721 25.2995 39.922 25.0213 39.9915L16.7054 42.0698C15.9878 42.2491 15.4865 42.8966 15.4924 43.6361C15.4989 43.9765 15.777 44.2487 16.1174 44.248Z"
        })
    });
}
/* harmony default export */ var microscope = (MicroscropeIcon);

;// CONCATENATED MODULE: ./components/product/modules/marketplace.tsx







function SupplierFooter() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("footer", {
        className: "jsx-d1affa4cd570a2f4",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                className: "jsx-d1affa4cd570a2f4",
                children: [
                    "Are you a carbon removal company interested in working with Watershed?",
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        href: "mailto:marketplace@watershed.com",
                        className: "jsx-d1affa4cd570a2f4",
                        children: "Let us know \u203A"
                    })
                ]
            }),
            (0,jsx_runtime.jsx)((styled_jsx_default()), {
                id: "d1affa4cd570a2f4",
                children: "footer.jsx-d1affa4cd570a2f4{grid-column:-1/1;text-align:center;padding:16px;line-height:1.375}p.jsx-d1affa4cd570a2f4{font-size:14px;margin:auto}a.jsx-d1affa4cd570a2f4{color:#265cff;font-weight:bold;white-space:nowrap}@media(min-width:520px){footer.jsx-d1affa4cd570a2f4{padding:24px 16px;border-top:1px solid#edf1f5}p.jsx-d1affa4cd570a2f4{font-size:unset}}"
            })
        ]
    });
}
function MarketplaceModule() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ModuleTwoUp, {
        headline: "High-quality carbon removal through the Watershed Marketplace",
        id: "marketplace",
        graphic: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    style: {
                        alignSelf: "center",
                        justifySelf: "center",
                        maxWidth: "100%",
                        margin: "auto"
                    },
                    className: "jsx-362b772de7bbd688",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(marketplace_gallery, {})
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(SupplierFooter, {})
            ]
        }),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "jsx-362b772de7bbd688",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                        className: "jsx-362b772de7bbd688",
                        children: [
                            "Invest in cutting-edge",
                            " ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: "/blog/carbon-removal-and-offsets-a-buyers-guide",
                                children: "carbon removal and high-quality carbon offsets"
                            }),
                            ", right from the Watershed dashboard. We work directly with a roster of innovative partners, so your funds make the largest impact."
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                        className: "jsx-362b772de7bbd688" + " " + "features-grid",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                className: "jsx-362b772de7bbd688",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(microscope, {}),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "jsx-362b772de7bbd688",
                                        children: "Get access to frontier carbon removal technologies, helping build the market for cutting-edge solutions while permanently removing carbon from the atmosphere."
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                className: "jsx-362b772de7bbd688",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(circle_checkmark, {}),
                                    "All projects are fully vetted by the Watershed team to ensure they\u2019re driving real impact."
                                ]
                            })
                        ]
                    })
                ]
            }),
            (0,jsx_runtime.jsx)((styled_jsx_default()), {
                id: "362b772de7bbd688",
                children: ".features-grid.jsx-362b772de7bbd688{padding:0;list-style:none;margin-top:24px}.features-grid.jsx-362b772de7bbd688 li.jsx-362b772de7bbd688{display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;margin-top:24px}.features-grid.jsx-362b772de7bbd688 li.jsx-362b772de7bbd688 svg{width:56px;height:56px;fill:#5f6575;margin-right:16px;-webkit-flex-shrink:0;-ms-flex-negative:0;flex-shrink:0}"
            })
        ]
    });
};

;// CONCATENATED MODULE: ./public/img/logo-ghg.png
/* harmony default export */ var logo_ghg = ({"src":"/_next/static/media/logo-ghg.e3468f79.png","height":98,"width":354,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAMAAABSSm3fAAAAElBMVEVRVFY7V1aMzMiQz8qW0s6c1dEzGKAeAAAABnRSTlMqFYy8uPHt/NH+AAAACXBIWXMAABYlAAAWJQFJUiTwAAAAF0lEQVQImWNgYmFkYGBgYGRgZgXRDAwAAMgAESdfAREAAAAASUVORK5CYII="});
;// CONCATENATED MODULE: ./public/img/logo-tcfd.png
/* harmony default export */ var logo_tcfd = ({"src":"/_next/static/media/logo-tcfd.d2dcafc0.png","height":68,"width":368,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAMAAABSSm3fAAAAFVBMVEVPp8xOpsxOp8xPp8xPp8xOp8xPp8xSyU7lAAAAB3RSTlMmbzoPWoA4wfNgswAAAAlwSFlzAAAWJQAAFiUBSVIk8AAAABhJREFUCJljYGVkZWRiYGBmYGNkYWEDMgABhgAqiWD2nQAAAABJRU5ErkJggg=="});
;// CONCATENATED MODULE: ./public/img/logo-cdp.png
/* harmony default export */ var logo_cdp = ({"src":"/_next/static/media/logo-cdp.9bb538c0.png","height":81,"width":238,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAADCAMAAACZFr56AAAAG1BMVEW0LTO0LDS8Jje5KDa3KjS0LTPMGT/YCkWzLTO1mkY+AAAACXRSTlMFZXCJQlYVGpoCYF9HAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAIElEQVQImQXBhwEAMAjDMGcA/f/iSmzMAjiWnMe1M1I/A2wAR8GVnXkAAAAASUVORK5CYII="});
;// CONCATENATED MODULE: ./public/img/logo-sasb.png
/* harmony default export */ var logo_sasb = ({"src":"/_next/static/media/logo-sasb.9bf08a22.png","height":136,"width":136,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAATlBMVEWLjY++srK6vr6anZ9MaXGJjI7y8PDV09SSlZeanJ6FiIryfoT1jZKYoKLq2NmPkpOVgIHqU1r/ysztdnzlwML/2duLj5HLz9DEycqvsrOXmJNcAAAAF3RSTlO0/vv3ACr+/ffxKv7+9/4q/v74/v74KiANSHoAAAAJcEhZcwAAFiUAABYlAUlSJPAAAABASURBVAiZBcEJAsAQDADBRYg4erf4/0c7g3z0TBGijWebFmG+d70m9K21s6ZAVufcoRmWevULio2UhkUkEjK7/F+UAm/fCkhkAAAAAElFTkSuQmCC"});
;// CONCATENATED MODULE: ./components/home/standards_logos.tsx







function StandardsLogos() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "jsx-c518241957de6df0" + " " + "standards",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "jsx-c518241957de6df0",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            href: "https://ghgprotocol.org/",
                            target: "_blank",
                            rel: "noreferrer",
                            className: "jsx-c518241957de6df0",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                src: logo_ghg,
                                alt: "Greenhouse Gas Protocol"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "jsx-c518241957de6df0",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            href: "https://www.cdp.net/en",
                            target: "_blank",
                            rel: "noreferrer",
                            className: "jsx-c518241957de6df0",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                src: logo_cdp,
                                alt: "CDP",
                                objectPosition: "center",
                                objectFit: "contain",
                                height: 40
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "jsx-c518241957de6df0",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            href: "https://www.sasb.org/",
                            target: "_blank",
                            rel: "noreferrer",
                            className: "jsx-c518241957de6df0",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                src: logo_sasb,
                                alt: "SASB",
                                objectPosition: "center",
                                objectFit: "contain",
                                height: 68
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "jsx-c518241957de6df0",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            href: "https://www.fsb-tcfd.org/",
                            target: "_blank",
                            rel: "noreferrer",
                            className: "jsx-c518241957de6df0",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                src: logo_tcfd,
                                alt: "Task Force on Climate-Related Financial Disclosures"
                            })
                        })
                    })
                ]
            }),
            (0,jsx_runtime.jsx)((styled_jsx_default()), {
                id: "c518241957de6df0",
                children: ".standards.jsx-c518241957de6df0{display:grid;grid-template-columns:repeat(2,1fr);grid-template-rows:repeat(2,1fr);gap:2px;background-color:#e3e7ee}.standards.jsx-c518241957de6df0>div.jsx-c518241957de6df0{background-color:var(--module-color,#f0f3f7);display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-webkit-justify-content:center;-moz-box-pack:center;-ms-flex-pack:center;justify-content:center;padding:36px 24px}"
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/home/climate_science_visual.tsx


function ClimateScienceVisual() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "540",
        height: "310",
        viewBox: "0 0 540 310",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-label": "Graphic showing inter-connected industries and their relevant greenhouse gases emitted",
        role: "img",
        style: {
            width: "100%",
            height: "auto"
        },
        className: "jsx-28f909908f6d222a",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                id: "climate-science-title",
                className: "jsx-28f909908f6d222a"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M56 93L205 215.5L319 145",
                stroke: "#E0E6EE",
                strokeWidth: "2",
                className: "jsx-28f909908f6d222a"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M208 58L422 67M422 67L56 95M422 67L320 146",
                stroke: "#E0E6EE",
                strokeWidth: "2",
                className: "jsx-28f909908f6d222a"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M208 57.5L68 237",
                stroke: "#E0E6EE",
                strokeWidth: "2",
                className: "jsx-28f909908f6d222a"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M208.5 57.5L383 256",
                stroke: "#E0E6EE",
                strokeWidth: "2",
                className: "jsx-28f909908f6d222a"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M174 14L208.5 56.5L258.5 33.5",
                stroke: "#E0E6EE",
                strokeWidth: "2",
                className: "jsx-28f909908f6d222a"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                id: "sector-factory",
                className: "jsx-28f909908f6d222a",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                        cx: "208",
                        cy: "57",
                        r: "56",
                        fill: "#00175C",
                        fillOpacity: "0.05",
                        className: "jsx-28f909908f6d222a"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                        cx: "258",
                        cy: "33",
                        r: "12",
                        fill: "#FF4D26",
                        className: "jsx-28f909908f6d222a"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                        cx: "174",
                        cy: "14",
                        r: "12",
                        fill: "#FFCC00",
                        className: "jsx-28f909908f6d222a"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                        cx: "208",
                        cy: "57",
                        r: "32",
                        fill: "#38D1D1",
                        className: "jsx-28f909908f6d222a"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("text", {
                        fill: "#FF4D26",
                        className: "jsx-28f909908f6d222a",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("tspan", {
                            x: "273.266",
                            y: "26.2656",
                            className: "jsx-28f909908f6d222a",
                            children: "N\u2082O"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("text", {
                        fill: "#FDB600",
                        className: "jsx-28f909908f6d222a",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("tspan", {
                            x: "135.277",
                            y: "11.2656",
                            className: "jsx-28f909908f6d222a",
                            children: "CO\u2082"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M221.75 69.5H194.25V69.5C193.56 69.4998 193 68.9403 193 68.25V54.4964V54.4968C193 53.8065 193.559 53.2469 194.25 53.2468H194.875L196.069 41.3125V41.3125C196.101 40.9931 196.37 40.75 196.691 40.75H198.684V40.75C199.005 40.75 199.274 40.9932 199.306 41.3125L200.45 52.7468L207.028 48.3629V48.3629C207.316 48.1715 207.704 48.2492 207.895 48.5364C207.963 48.639 208 48.7595 208 48.8828V52.7133L214.528 48.3629V48.3629C214.816 48.1715 215.204 48.2491 215.395 48.5363C215.463 48.6389 215.5 48.7595 215.5 48.8829V52.7133L222.028 48.3629V48.3629C222.316 48.1714 222.704 48.249 222.895 48.5362C222.963 48.6389 223 48.7595 223 48.8828V68.25C223 68.9404 222.44 69.5 221.75 69.5V69.5H221.75ZM205.5 57.625C205.5 57.2798 205.22 57 204.875 57H201.125V57C200.78 57 200.5 57.2798 200.5 57.625V60.125V60.125C200.5 60.4702 200.78 60.75 201.125 60.75H204.875V60.75C205.22 60.75 205.5 60.4702 205.5 60.125V57.625ZM205.5 63.875C205.5 63.5298 205.22 63.25 204.875 63.25H201.125V63.25C200.78 63.25 200.5 63.5298 200.5 63.875V66.375V66.375C200.5 66.7202 200.78 67 201.125 67H204.875V67C205.22 67 205.5 66.7202 205.5 66.375V63.875ZM213 57.625C213 57.2798 212.72 57 212.375 57H208.625V57C208.28 57 208 57.2798 208 57.625V60.125V60.125C208 60.4702 208.28 60.75 208.625 60.75H212.375V60.75C212.72 60.75 213 60.4702 213 60.125V57.625ZM213 63.875C213 63.5298 212.72 63.25 212.375 63.25H208.625V63.25C208.28 63.25 208 63.5298 208 63.875V66.375V66.375C208 66.7202 208.28 67 208.625 67H212.375V67C212.72 67 213 66.7202 213 66.375V63.875ZM220.5 57.625C220.5 57.2798 220.22 57 219.875 57H216.125V57C215.78 57 215.5 57.2798 215.5 57.625V60.125V60.125C215.5 60.4702 215.78 60.75 216.125 60.75H219.875V60.75C220.22 60.75 220.5 60.4702 220.5 60.125V57.625ZM220.5 63.875C220.5 63.5298 220.22 63.25 219.875 63.25H216.125V63.25C215.78 63.25 215.5 63.5298 215.5 63.875V66.375V66.375C215.5 66.7202 215.78 67 216.125 67H219.875V67C220.22 67 220.5 66.7202 220.5 66.375V63.875Z",
                        fill: "white",
                        className: "jsx-28f909908f6d222a"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                id: "sector-airplane",
                className: "jsx-28f909908f6d222a",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M74 143.5L56 92.5",
                        stroke: "#E0E6EE",
                        strokeWidth: "2",
                        className: "jsx-28f909908f6d222a"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                        cx: "56",
                        cy: "93",
                        r: "56",
                        fill: "#00175C",
                        fillOpacity: "0.05",
                        className: "jsx-28f909908f6d222a"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                        cx: "74",
                        cy: "143",
                        r: "12",
                        fill: "#FFCC00",
                        className: "jsx-28f909908f6d222a"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                        cx: "56",
                        cy: "93",
                        r: "32",
                        fill: "#265CFF",
                        className: "jsx-28f909908f6d222a"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("text", {
                        fill: "#FDB600",
                        className: "jsx-28f909908f6d222a",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("tspan", {
                            x: "86.2773",
                            y: "163.266",
                            className: "jsx-28f909908f6d222a",
                            children: "CO\u2082"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M59.1338 88.3233L62.3026 89.9079C62.3843 89.1655 62.6415 88.638 63.4737 88.638C64.7527 88.638 64.7237 89.7991 64.7237 91.1185L70.3219 93.9175V93.9175C70.7454 94.1293 71.0129 94.5621 71.0128 95.0356V97.3862V97.3863C71.0128 97.7315 70.733 98.0113 70.3878 98.0113C70.3412 98.0113 70.2948 98.0061 70.2493 97.9957L58.9856 95.4358L58.9856 95.4357C58.8695 98.9535 58.4145 102.452 57.627 105.882L61.2611 107.901V107.901C61.6147 108.098 61.7419 108.544 61.5451 108.898C61.4017 109.156 61.1176 109.302 60.8243 109.27V109.27C57.6267 108.915 54.3995 108.915 51.2019 109.27V109.27C50.7996 109.314 50.4375 109.024 50.3932 108.622C50.3609 108.328 50.5074 108.045 50.7651 107.901L54.3991 105.882L54.3991 105.882C53.6115 102.452 53.1566 98.9535 53.0406 95.4357L41.7765 97.9957V97.9957C41.4399 98.0723 41.105 97.8614 41.0285 97.5248C41.0181 97.4793 41.0129 97.4328 41.0129 97.3862V95.0355V95.0356C41.0129 94.5621 41.2805 94.1292 41.704 93.9175L47.2629 91.138H47.2617C47.2617 89.8105 47.2273 88.638 48.4738 88.638C49.3397 88.638 49.6018 89.1749 49.6837 89.9277L52.8922 88.3233C52.9797 77.8013 54.5431 76.7629 56.013 76.7629C57.483 76.7629 59.0466 77.8012 59.1338 88.3233L59.1338 88.3233Z",
                        fill: "white",
                        className: "jsx-28f909908f6d222a"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                id: "sector-gas",
                className: "jsx-28f909908f6d222a",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M383.5 254L334 277",
                        stroke: "#E0E6EE",
                        strokeWidth: "2",
                        className: "jsx-28f909908f6d222a"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                        cx: "383",
                        cy: "254",
                        r: "56",
                        fill: "#00175C",
                        fillOpacity: "0.05",
                        className: "jsx-28f909908f6d222a"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                        cx: "334",
                        cy: "277",
                        r: "12",
                        fill: "#FFCC00",
                        className: "jsx-28f909908f6d222a"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                        cx: "383",
                        cy: "254",
                        r: "32",
                        fill: "#1FBEF9",
                        className: "jsx-28f909908f6d222a"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("text", {
                        fill: "#FDB600",
                        className: "jsx-28f909908f6d222a",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("tspan", {
                            x: "301.277",
                            y: "293.266",
                            className: "jsx-28f909908f6d222a",
                            children: "CO\u2082"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        x: "371",
                        y: "270",
                        width: "24",
                        height: "3",
                        rx: "1.5",
                        fill: "white",
                        className: "jsx-28f909908f6d222a"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M386.917 266.156V266.156C388.285 264.998 389.307 263.484 389.869 261.781V261.781C389.921 261.611 389.826 261.431 389.656 261.378C389.626 261.369 389.595 261.364 389.564 261.364H389.564C388.127 261.391 386.699 261.596 385.312 261.973V261.973C385.146 262.037 384.959 261.953 384.895 261.787C384.865 261.71 384.866 261.624 384.898 261.548V261.548C385.38 260.082 385.587 258.54 385.506 257C385.506 253.687 383.495 251.122 382.787 250.242V250.242C382.681 250.107 382.487 250.084 382.353 250.189C382.305 250.226 382.269 250.277 382.25 250.335C381.306 253.347 377.381 257.668 377.381 261.997C377.381 264.599 379.11 265.729 379.237 266.332C379.342 266.829 379.089 267.105 378.613 266.955C375.448 265.958 370.506 261.406 370.506 255.751C370.506 245.476 380.506 243.425 380.506 238.261V238.261C380.443 237.601 380.24 236.962 379.912 236.385V236.385C379.83 236.135 379.967 235.867 380.217 235.785C380.306 235.756 380.402 235.754 380.493 235.779C383.707 236.645 391.131 241.133 391.131 250.129V250.129C391.072 252.065 390.648 253.972 389.881 255.751C389.881 255.751 391.983 255.386 394.831 255.123V255.123C395.194 255.112 395.498 255.397 395.509 255.76C395.51 255.792 395.509 255.824 395.505 255.856C395.505 260.194 392.116 265.195 387.294 266.996C386.857 267.159 386.564 266.473 386.917 266.156V266.156Z",
                        fill: "white",
                        className: "jsx-28f909908f6d222a"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                id: "sector-food",
                className: "jsx-28f909908f6d222a",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M205 215L183 165M205 215L255 235M205 215L175 260.5",
                        stroke: "#E0E6EE",
                        strokeWidth: "2",
                        className: "jsx-28f909908f6d222a"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                        cx: "205",
                        cy: "215",
                        r: "56",
                        fill: "#00175C",
                        fillOpacity: "0.05",
                        className: "jsx-28f909908f6d222a"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                        cx: "175",
                        cy: "260",
                        r: "12",
                        fill: "#FF7F22",
                        className: "jsx-28f909908f6d222a"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                        cx: "255",
                        cy: "235",
                        r: "12",
                        fill: "#FF4D26",
                        className: "jsx-28f909908f6d222a"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                        cx: "183",
                        cy: "165",
                        r: "12",
                        fill: "#FFCC00",
                        className: "jsx-28f909908f6d222a"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                        cx: "205",
                        cy: "215",
                        r: "32",
                        fill: "#1FBEF9",
                        className: "jsx-28f909908f6d222a"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("text", {
                        fill: "#FF7F22",
                        className: "jsx-28f909908f6d222a",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("tspan", {
                            x: "154.131",
                            y: "285.266",
                            className: "jsx-28f909908f6d222a",
                            children: "CH\u2084"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("text", {
                        fill: "#FF4D26",
                        className: "jsx-28f909908f6d222a",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("tspan", {
                            x: "264.266",
                            y: "258.266",
                            className: "jsx-28f909908f6d222a",
                            children: "N\u2082O"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("text", {
                        fill: "#FDB600",
                        className: "jsx-28f909908f6d222a",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("tspan", {
                            x: "155.277",
                            y: "148.266",
                            className: "jsx-28f909908f6d222a",
                            children: "CO\u2082"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M189.812 217.25H204.438V217.25C204.748 217.25 205 216.998 205 216.687C205 213.307 203.285 210.5 197.125 210.5C190.965 210.5 189.25 213.307 189.25 216.687V216.687C189.25 216.998 189.502 217.25 189.812 217.25V217.25ZM204.438 224H189.812V224C189.502 224 189.25 224.252 189.25 224.562V226.25V226.25C189.25 226.871 189.754 227.375 190.375 227.375H203.875V227.375C204.496 227.375 205 226.871 205 226.25V224.562V224.562C205 224.252 204.748 224 204.438 224V224ZM221.866 207.566L221.585 206.442V206.442C221.522 206.191 221.297 206.016 221.038 206.016H217.39L217.943 199.396V199.396C217.969 199.086 217.738 198.814 217.429 198.789C217.429 198.789 217.428 198.789 217.428 198.789L216.305 198.695V198.695C215.995 198.669 215.723 198.899 215.697 199.209L215.128 206.016H206.961V206.016C206.703 206.016 206.478 206.191 206.415 206.442L206.133 207.566V207.566C206.061 207.864 206.244 208.165 206.542 208.237C206.567 208.243 206.593 208.248 206.619 208.25H221.381V208.25C221.686 208.22 221.91 207.948 221.879 207.642C221.877 207.617 221.873 207.591 221.866 207.566V207.566ZM220.181 209.375H207.806V209.375C207.495 209.375 207.243 209.627 207.243 209.938C207.243 209.953 207.244 209.969 207.245 209.985L208.609 226.344V226.344C208.658 226.927 209.146 227.375 209.731 227.375H218.256V227.375C218.841 227.375 219.329 226.927 219.377 226.344L220.742 209.985V209.985C220.768 209.675 220.538 209.403 220.228 209.377C220.213 209.376 220.197 209.375 220.181 209.375V209.375ZM204.438 218.375H201.625C198.287 218.375 196.683 220.625 196 220.625C195.317 220.625 193.713 218.375 190.375 218.375H189.812C188.57 218.375 188.125 219.382 188.125 220.625C188.125 221.868 188.57 222.875 189.812 222.875H204.438C205.68 222.875 206.125 221.868 206.125 220.625C206.125 219.382 205.68 218.375 204.438 218.375V218.375Z",
                        fill: "white",
                        className: "jsx-28f909908f6d222a"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                id: "sector-transportation",
                className: "jsx-28f909908f6d222a",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M512 139L483.5 184.5",
                        stroke: "#E0E6EE",
                        strokeWidth: "2",
                        className: "jsx-28f909908f6d222a"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                        cx: "484",
                        cy: "184",
                        r: "56",
                        fill: "#00175C",
                        fillOpacity: "0.05",
                        className: "jsx-28f909908f6d222a"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                        cx: "512",
                        cy: "139",
                        r: "12",
                        fill: "#FFCC00",
                        className: "jsx-28f909908f6d222a"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                        cx: "484",
                        cy: "184",
                        r: "32",
                        fill: "#265CFF",
                        className: "jsx-28f909908f6d222a"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("text", {
                        fill: "#FDB600",
                        className: "jsx-28f909908f6d222a",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("tspan", {
                            x: "495.277",
                            y: "120.266",
                            className: "jsx-28f909908f6d222a",
                            children: "CO\u2082"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M497.829 183.98V183.98C497.405 184.192 497.138 184.625 497.138 185.098V189.638C497.138 192.775 492.721 193.388 484.013 193.388C475.304 193.388 470.888 192.775 470.888 189.638V185.098V185.098C470.888 184.625 470.62 184.192 470.197 183.98L469.358 183.561V183.561C469.147 183.455 469.013 183.239 469.013 183.002V181.513V181.513C469.013 181.168 469.293 180.888 469.638 180.888H471.653L473.702 174.741V174.741C474.1 173.54 475.079 172.622 476.302 172.301C477.662 171.941 479.588 171.513 484.013 171.513C488.438 171.513 490.363 171.941 491.723 172.301V172.301C492.947 172.622 493.925 173.54 494.323 174.741L496.372 180.888H498.388V180.888C498.733 180.888 499.013 181.168 499.013 181.513V183.002V183.002C499.013 183.239 498.879 183.455 498.667 183.561L497.829 183.98ZM473.388 186.601V187.661V187.661C473.404 188.417 474.029 189.018 474.785 189.004H476.991H476.991C477.747 189.018 478.372 188.417 478.388 187.661V187.661C478.385 187.145 478.084 186.676 477.616 186.459L475.411 185.4V185.4C475.216 185.306 475.002 185.257 474.786 185.257V185.257C474.029 185.244 473.404 185.845 473.388 186.601V186.601ZM493.346 180.065L491.853 175.532V175.532C491.725 175.134 491.403 174.827 490.998 174.718C490.014 174.455 488.336 174.013 484.013 174.013C479.69 174.013 478.012 174.455 477.029 174.718V174.718C476.623 174.827 476.301 175.133 476.172 175.533L474.679 180.065V180.065C474.57 180.392 474.745 180.746 475.072 180.856C475.134 180.876 475.199 180.887 475.265 180.888H492.76V180.888C493.105 180.885 493.382 180.603 493.379 180.259C493.378 180.193 493.367 180.128 493.346 180.065V180.065ZM494.638 186.601V186.601C494.622 185.845 493.997 185.243 493.24 185.257V185.257C493.024 185.257 492.81 185.306 492.615 185.4L490.41 186.459V186.459C489.942 186.676 489.641 187.145 489.638 187.661V187.661C489.654 188.417 490.279 189.018 491.035 189.004H493.24V189.004C493.997 189.018 494.622 188.417 494.638 187.661V186.601ZM476.04 194.032V194.032C476.321 194.096 476.519 194.349 476.513 194.638V195.263V195.263C476.512 195.953 475.953 196.512 475.263 196.513H472.763V196.513C472.073 196.512 471.514 195.953 471.513 195.263V194.013V194.013C471.48 193.7 471.707 193.421 472.019 193.388C472.059 193.384 472.098 193.384 472.138 193.388C472.433 193.388 474.281 193.878 476.04 194.032V194.032ZM495.888 193.388V193.388C496.2 193.355 496.48 193.582 496.513 193.894C496.517 193.934 496.517 193.973 496.513 194.013V195.263V195.263C496.512 195.953 495.953 196.512 495.263 196.513H492.763V196.513C492.073 196.512 491.514 195.953 491.513 195.263V194.638V194.638C491.507 194.349 491.704 194.096 491.986 194.032C493.744 193.878 495.592 193.388 495.888 193.388V193.388Z",
                        fill: "white",
                        className: "jsx-28f909908f6d222a"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                id: "sector-shipping",
                className: "jsx-28f909908f6d222a",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M470 44L421 66",
                        stroke: "#E0E6EE",
                        strokeWidth: "2",
                        className: "jsx-28f909908f6d222a"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                        cx: "421",
                        cy: "66",
                        r: "56",
                        fill: "#00175C",
                        fillOpacity: "0.05",
                        className: "jsx-28f909908f6d222a"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                        cx: "470",
                        cy: "44",
                        r: "12",
                        fill: "#FFCC00",
                        className: "jsx-28f909908f6d222a"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                        cx: "421",
                        cy: "66",
                        r: "32",
                        fill: "#1FBEF9",
                        className: "jsx-28f909908f6d222a"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("text", {
                        fill: "#FDB600",
                        className: "jsx-28f909908f6d222a",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("tspan", {
                            x: "482.277",
                            y: "34.2656",
                            className: "jsx-28f909908f6d222a",
                            children: "CO\u2082"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M434.123 73.6432L421.623 80.8288V80.8288C421.237 81.0507 420.763 81.0507 420.377 80.8288L407.875 73.6423V73.6423C407.488 73.4193 407.25 73.0066 407.25 72.56V59.439V59.439C407.25 58.9925 407.488 58.5798 407.875 58.357L411.197 56.4474V56.4474C411.39 56.3364 411.627 56.3367 411.82 56.4483L425.687 64.4833V64.4833C425.881 64.5957 426 64.8027 426 65.0265V68.187V68.187C425.999 68.3596 426.139 68.4999 426.312 68.5005C426.368 68.5006 426.423 68.4855 426.472 68.4566L429.444 66.6853V66.6853C429.634 66.572 429.75 66.3672 429.75 66.1461V62.6726V62.6726C429.75 62.5607 429.691 62.4572 429.594 62.4011L415.744 54.3761V54.3761C415.594 54.2889 415.543 54.0966 415.63 53.9465C415.658 53.8991 415.697 53.8597 415.745 53.8323L420.377 51.1698V51.1698C420.763 50.9479 421.237 50.9479 421.623 51.1698L434.125 58.3568V58.3568C434.512 58.5799 434.75 58.9927 434.75 59.4394V72.5581V72.5582C434.75 73.006 434.511 73.4197 434.123 73.6432L434.123 73.6432ZM414.75 69.9404V69.9404C414.75 69.7167 414.63 69.51 414.436 69.3985L410.218 66.9735V66.9735C410.069 66.8875 409.878 66.939 409.792 67.0886C409.764 67.1361 409.75 67.1899 409.75 67.2447V71.4732L409.75 71.4732C409.75 71.6969 409.87 71.9036 410.063 72.0151L414.282 74.4401V74.4401C414.431 74.5261 414.622 74.4745 414.708 74.3248C414.736 74.2773 414.75 74.2235 414.75 74.1688L414.75 69.9404Z",
                        fill: "white",
                        className: "jsx-28f909908f6d222a"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                id: "sector-lightbulb",
                className: "jsx-28f909908f6d222a",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M68 237L25 204",
                        stroke: "#E0E6EE",
                        strokeWidth: "2",
                        className: "jsx-28f909908f6d222a"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                        cx: "68",
                        cy: "236",
                        r: "56",
                        fill: "#00175C",
                        fillOpacity: "0.05",
                        className: "jsx-28f909908f6d222a"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                        cx: "25",
                        cy: "204",
                        r: "12",
                        fill: "#FFCC00",
                        className: "jsx-28f909908f6d222a"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                        cx: "68",
                        cy: "236",
                        r: "32",
                        fill: "#38D1D1",
                        className: "jsx-28f909908f6d222a"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("text", {
                        fill: "#FDB600",
                        className: "jsx-28f909908f6d222a",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("tspan", {
                            x: "7.27734",
                            y: "185.266",
                            className: "jsx-28f909908f6d222a",
                            children: "CO\u2082"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M72.5426 241.374C72.1789 242.618 71.8829 243.512 70.6238 243.512H65.4043C64.1451 243.512 63.849 242.617 63.4856 241.374C62.2716 237.222 58.6892 235.845 58.6418 230.482V230.482C58.5918 225.306 62.7475 221.069 67.9239 221.019C73.1002 220.969 77.3371 225.125 77.3871 230.301C77.3876 230.362 77.3876 230.422 77.3871 230.482C77.339 235.845 73.7563 237.222 72.5426 241.374V241.374ZM64.8868 244.762H71.1411V244.762C71.8316 244.762 72.3914 245.322 72.3914 246.013C72.3914 246.703 71.8316 247.263 71.1411 247.263H64.8868V247.263C64.1963 247.263 63.6366 246.703 63.6366 246.013C63.6366 245.322 64.1963 244.762 64.8868 244.762V244.762ZM65.6188 248.513H70.4093V248.513C70.8136 248.513 71.1413 248.841 71.1412 249.245C71.1412 249.245 71.1412 249.245 71.1412 249.245V249.245C71.1412 249.577 71.0095 249.895 70.7751 250.129L70.2578 250.647V250.647C70.0236 250.881 69.7058 251.013 69.3744 251.013H66.6535H66.6535C66.3221 251.013 66.0044 250.881 65.7701 250.647L65.2528 250.129V250.129C65.0185 249.895 64.8868 249.577 64.8868 249.245V249.245C64.8867 248.841 65.2143 248.513 65.6187 248.513C65.6187 248.513 65.6188 248.513 65.6188 248.513V248.513Z",
                        fill: "white",
                        className: "jsx-28f909908f6d222a"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                id: "sector-truck",
                className: "jsx-28f909908f6d222a",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M365.5 173.5L319.5 143.5",
                        stroke: "#E0E6EE",
                        strokeWidth: "2",
                        className: "jsx-28f909908f6d222a"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                        cx: "319",
                        cy: "144",
                        r: "56",
                        fill: "#00175C",
                        fillOpacity: "0.05",
                        className: "jsx-28f909908f6d222a"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                        cx: "365",
                        cy: "173",
                        r: "12",
                        fill: "#FFCC00",
                        className: "jsx-28f909908f6d222a"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                        cx: "319",
                        cy: "144",
                        r: "32",
                        fill: "#265CFF",
                        className: "jsx-28f909908f6d222a"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("text", {
                        fill: "#FDB600",
                        className: "jsx-28f909908f6d222a",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("tspan", {
                            x: "382.277",
                            y: "175.266",
                            className: "jsx-28f909908f6d222a",
                            children: "CO\u2082"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M336.434 147.109L335.886 150.452V150.452C335.788 151.056 335.266 151.5 334.654 151.5H331.436V151.5C331.207 151.496 330.998 151.369 330.887 151.169V151.169C330.107 149.827 328.672 149 327.119 149H324.623V149C324.278 149 323.998 148.72 323.998 148.375C323.998 148.375 323.998 148.375 323.998 148.375V138.375V138.375C323.998 138.03 324.278 137.75 324.623 137.75C324.623 137.75 324.623 137.75 324.623 137.75H334.031V137.75C334.643 137.75 335.164 138.193 335.263 138.796L336.433 145.891V145.891C336.5 146.294 336.5 146.706 336.434 147.109H336.434ZM333.015 140.512V140.512C332.991 140.361 332.86 140.25 332.708 140.25H326.807V140.25C326.635 140.25 326.495 140.39 326.495 140.562V143.688V143.688C326.495 143.86 326.635 144 326.807 144H329.425V144C330.002 144 330.495 144.419 330.588 144.988V144.988C330.613 145.139 330.743 145.25 330.896 145.25H333.429V145.25C333.602 145.25 333.742 145.11 333.741 144.937C333.741 144.92 333.74 144.903 333.737 144.887L333.015 140.512ZM321.508 152.75H315.464V152.75C315.315 152.748 315.188 152.641 315.161 152.495V152.495C315.022 151.81 314.719 151.169 314.28 150.625V150.625C314.2 150.526 314.217 150.38 314.317 150.3C314.358 150.267 314.41 150.25 314.463 150.25H322.133V150.25C322.478 150.25 322.758 150.529 322.758 150.875C322.758 150.875 322.758 150.875 322.758 150.875V151.5V151.5C322.758 152.19 322.198 152.75 321.508 152.75C321.508 152.75 321.508 152.75 321.508 152.75V152.75ZM322.133 149H304.625V149C304.28 149 304 148.72 304 148.375V134V134C304 133.31 304.56 132.75 305.25 132.75C305.25 132.75 305.25 132.75 305.251 132.75H321.508V132.75C322.198 132.75 322.758 133.309 322.758 133.999C322.758 134 322.758 134 322.758 134V148.375V148.375C322.758 148.72 322.478 149 322.133 149C322.133 149 322.133 149 322.133 149H322.133ZM304.625 150.25H307.294V150.25C307.421 150.249 307.526 150.352 307.527 150.479C307.527 150.532 307.509 150.584 307.476 150.625V150.625C307.037 151.169 306.735 151.81 306.595 152.495V152.495C306.568 152.641 306.442 152.748 306.293 152.75H305.25V152.75C304.56 152.75 304 152.191 304 151.501C304 151.5 304 151.5 304 151.5V150.875V150.875C304 150.53 304.28 150.25 304.625 150.25H304.625ZM310.87 150.25V150.25C312.596 150.249 313.996 151.647 313.997 153.373C313.998 155.099 312.6 156.499 310.874 156.5C309.148 156.501 307.748 155.103 307.747 153.377C307.747 153.376 307.747 153.376 307.747 153.375V153.375C307.747 151.65 309.145 150.251 310.87 150.25C310.87 150.25 310.87 150.25 310.87 150.25L310.87 150.25ZM327.13 150.25V150.25C328.856 150.249 330.256 151.647 330.257 153.373C330.258 155.099 328.86 156.499 327.134 156.5C325.408 156.501 324.008 155.103 324.007 153.377C324.007 153.376 324.007 153.376 324.007 153.375V153.375C324.006 151.65 325.404 150.251 327.13 150.25C327.13 150.25 327.13 150.25 327.13 150.25L327.13 150.25Z",
                        fill: "white",
                        className: "jsx-28f909908f6d222a"
                    })
                ]
            }),
            (0,jsx_runtime.jsx)((styled_jsx_default()), {
                id: "28f909908f6d222a",
                children: "svg.jsx-28f909908f6d222a{margin:auto;pointer-events:none}text.jsx-28f909908f6d222a{font-family:ui-rounded,var(--font-family);font-weight:bold;font-size:14px;opacity:0;-webkit-transition:opacity.125s ease-in-out;-moz-transition:opacity.125s ease-in-out;-o-transition:opacity.125s ease-in-out;transition:opacity.125s ease-in-out}circle.jsx-28f909908f6d222a{-webkit-transition:fill.125s ease-in-out;-moz-transition:fill.125s ease-in-out;-o-transition:fill.125s ease-in-out;transition:fill.125s ease-in-out}g.jsx-28f909908f6d222a{pointer-events:all}g.jsx-28f909908f6d222a:hover text.jsx-28f909908f6d222a{opacity:1}svg.jsx-28f909908f6d222a:hover g.jsx-28f909908f6d222a:not(:hover) circle.jsx-28f909908f6d222a:not(:first-of-type){fill:#bdc7d6}"
            })
        ]
    });
};

;// CONCATENATED MODULE: ./public/img/product/portfolio_builder.png
/* harmony default export */ var portfolio_builder = ({"src":"/_next/static/media/portfolio_builder.bea953bc.png","height":752,"width":1136,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAGCAMAAADJ2y/JAAAARVBMVEXR4MctMkjk6dGIjp7E2b2ryrExO1FMaXE3SV/Iy7XohHu5yMbwzrmuvLzh2MRgoZTx9N3l69JOfnlbjoxcjotXe3PS6cocvLgsAAAAD3RSTlP9/nh4/fz+AP6LbayzoJazDe4QAAAACXBIWXMAAAsTAAALEwEAmpwYAAAANklEQVQImRXBCRaAIAhAwW+hQotgpfc/qq8Z6rHXH+06bzPbiAm9R4BIzgK4f+N53VEtKRXVBS5bAb3zSH9nAAAAAElFTkSuQmCC"});
;// CONCATENATED MODULE: ./components/product/modules/portfolio_builder.tsx





function PortfolioBuilderModule() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ModuleColumn, {
        graphic: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
            src: portfolio_builder,
            alt: "Illustration of a carbon removal portfolio on top of growing plants",
            placeholder: "blur",
            draggable: false
        }),
        headline: "Fund a portfolio",
        className: "module-portfolio-builder",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "jsx-f56fa1605875d6ca",
                children: "Build a custom portfolio of bets, mixing long-term investments in cutting-edge projects with quick emissions reductions. Design your portfolio and track your impact in the dashboard; we\u2019ll handle the paperwork."
            }),
            (0,jsx_runtime.jsx)((styled_jsx_default()), {
                id: "f56fa1605875d6ca",
                children: "section.module-portfolio-builder{background-color:hsl(68deg 49%91%);-webkit-box-pack:justify;-webkit-justify-content:space-between;-moz-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}section.module-portfolio-builder .padded-box{background-image:-webkit-linear-gradient(hsl(68deg 69%96%),hsl(68deg 49%91%));background-image:-moz-linear-gradient(hsl(68deg 69%96%),hsl(68deg 49%91%));background-image:-o-linear-gradient(hsl(68deg 69%96%),hsl(68deg 49%91%));background-image:linear-gradient(hsl(68deg 69%96%),hsl(68deg 49%91%));padding-bottom:0!important}.module-portfolio-builder h3{color:hsl(70,4%,24%)}.module-portfolio-builder p{color:hsl(70,9%,34%);padding-bottom:18px;margin-bottom:auto!important}"
            })
        ]
    });
};

;// CONCATENATED MODULE: ./public/img/product/suppliers.png
/* harmony default export */ var suppliers = ({"src":"/_next/static/media/suppliers.e4f0b835.png","height":621,"width":1136,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAFCAMAAABPT11nAAAAOVBMVEXGz8x+m5xsnZhxrqeluayytqq/zMPQ18uOm5qWs619pqBmkJHGyMIpX2m+4MdReIZ+kZd/tKlbdYgqYPREAAAACXBIWXMAABYlAAAWJQFJUiTwAAAALklEQVQImR3BBw4AIAgEsANEhtv/P9bEFkDFZ0Ze0Q1aMk9ogTeeQcK4bYVvGQ8RPQEGyxnuxgAAAABJRU5ErkJggg=="});
;// CONCATENATED MODULE: ./components/product/modules/suppliers.tsx





function SuppliersModule() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ModuleColumn, {
        graphic: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
            src: suppliers,
            alt: "Illustration of factory with complex array of infrastructure",
            placeholder: "blur"
        }),
        headline: "Go deep on suppliers",
        className: "module-suppliers",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "jsx-816de3845332bd78",
                children: "Most carbon is in the supply chain, and it\u2019s been a black box for too long. Watershed helps you track carbon down to every supplier. Move from industry averages to fine-grained calculations for specific vendors, and work with them to cut emissions."
            }),
            (0,jsx_runtime.jsx)((styled_jsx_default()), {
                id: "816de3845332bd78",
                children: "section.module-suppliers{background-color:hsl(142deg 8%80%);--section-link:#fff}section.module-suppliers .padded-box{background-image:-webkit-linear-gradient(hsl(142deg 8%90%),hsl(142deg 8%80%));background-image:-moz-linear-gradient(hsl(142deg 8%90%),hsl(142deg 8%80%));background-image:-o-linear-gradient(hsl(142deg 8%90%),hsl(142deg 8%80%));background-image:linear-gradient(hsl(142deg 8%90%),hsl(142deg 8%80%));padding-bottom:16px!important}.module-suppliers h3{color:hsl(142deg 8%20%)}.module-suppliers p{color:hsl(142deg 8%30%)}"
            })
        ]
    });
};

// EXTERNAL MODULE: ./components/icons/chevron_right.tsx
var chevron_right = __webpack_require__(447);
;// CONCATENATED MODULE: ./components/product/modules/removal_primer.tsx






var resources = [
    {
        source: "Watershed",
        image: "/favicon.svg",
        url: "https://watershed.com/blog/carbon-removal-and-offsets-a-buyers-guide",
        title: "Carbon removal and offsets: a buyer\u2019s guide",
        body: "Our introductory guide on the topic"
    },
    {
        source: "Shopify",
        image: "/img/testimonials/shopify.svg",
        url: "https://www.shopify.com/about/environment/sustainability-fund",
        title: "Shopify\u2019s $5M Sustainability Fund",
        body: "A top-tier CDR commitment from one of our customers"
    },
    {
        source: "Stripe",
        image: "https://logo.clearbit.com/stripe.com",
        url: "https://stripe.com/climate",
        title: "Stripe Climate",
        body: "Embedding CDR funding into business models at scale"
    },
    {
        source: "CDR Primer",
        image: "https://logo.clearbit.com/cdrprimer.org",
        url: "https://cdrprimer.org/",
        title: "Carbon Dioxide Removal Primer",
        body: "A comprehensive guide to all things carbon removal"
    }, 
];
function RemovalPrimerModule() {
    var t = (0,index_modern/* useI18n */.QT)().t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ModuleColumn, {
        headline: "Understanding frontier carbon removal",
        className: "module-removal-primer",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                style: {
                    marginBottom: "auto"
                },
                className: "jsx-c25988f53642c7fd",
                children: [
                    "Permanent carbon dioxide removal (CDR) has quickly become a core component of running a high-impact climate ",
                    t("common.program"),
                    ". If you\u2019re new to CDR, here are some resources to get you started."
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("ol", {
                className: "jsx-c25988f53642c7fd",
                children: resources.map(function(milestone) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        className: "jsx-c25988f53642c7fd",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                            href: milestone.url,
                            target: "_blank",
                            rel: "noopener noreferrer",
                            className: "jsx-c25988f53642c7fd",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                    width: 128,
                                    height: 128,
                                    src: milestone.image,
                                    alt: milestone.source,
                                    className: "logo"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "jsx-c25988f53642c7fd",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                            className: "jsx-c25988f53642c7fd",
                                            children: milestone.title
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "jsx-c25988f53642c7fd",
                                            children: milestone.body
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(chevron_right/* default */.Z, {})
                            ]
                        })
                    }, milestone.url);
                })
            }),
            (0,jsx_runtime.jsx)((styled_jsx_default()), {
                id: "39a109bcbd576c7a",
                children: "section.module-removal-primer{background-color:var(--module-color-hover)}section.module-removal-primer .padded-box{display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-webkit-flex-direction:column;-moz-box-orient:vertical;-moz-box-direction:normal;-ms-flex-direction:column;flex-direction:column;height:100%}"
            }),
            (0,jsx_runtime.jsx)((styled_jsx_default()), {
                id: "bee139a2c84433cf",
                children: "ol.jsx-c25988f53642c7fd{margin:24px -16px 0;padding:0;display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-webkit-flex-direction:column;-moz-box-orient:vertical;-moz-box-direction:normal;-ms-flex-direction:column;flex-direction:column;gap:16px;list-style:none}li.jsx-c25988f53642c7fd{width:100%;-webkit-border-radius:16px;-moz-border-radius:16px;border-radius:16px;padding:0;margin:0;overflow:hidden;line-height:1.375}li.jsx-c25988f53642c7fd a.jsx-c25988f53642c7fd{background-color:#fff;-webkit-transition:.125s background-color ease-in-out;-moz-transition:.125s background-color ease-in-out;-o-transition:.125s background-color ease-in-out;transition:.125s background-color ease-in-out;padding:16px;display:grid;grid-template-columns:48px 1fr auto;-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center;-webkit-column-gap:12px;-moz-column-gap:12px;column-gap:12px;text-decoration:none;font-weight:initial}@media screen and (min-width:520px){ol.jsx-c25988f53642c7fd{margin-bottom:-8px}li.jsx-c25988f53642c7fd{-webkit-column-gap:16px;-moz-column-gap:16px;column-gap:16px}}li.jsx-c25988f53642c7fd a.jsx-c25988f53642c7fd:hover,li.jsx-c25988f53642c7fd a.jsx-c25988f53642c7fd:focus{background-color:#f0f3f7}li.jsx-c25988f53642c7fd strong.jsx-c25988f53642c7fd{color:initial}li.jsx-c25988f53642c7fd .logo{width:64px;height:64px;-webkit-border-radius:12px;-moz-border-radius:12px;border-radius:12px;overflow:hidden}"
            })
        ]
    });
};

;// CONCATENATED MODULE: ./public/img/product/presentation/1.png
/* harmony default export */ var _1 = ({"src":"/_next/static/media/1.5a1f5428.png","height":746,"width":1194,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAFCAMAAABPT11nAAAAHlBMVEX39vfx8vL8+/vp6eqbp6jd4+bP2d/a29Xm5NmqtbqY9KEBAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAJ0lEQVQImU3GyREAIAwDsXWci/4bZvihl5BNIMC78xKTJ5GguprPBQkBAFgyW/4kAAAAAElFTkSuQmCC"});
;// CONCATENATED MODULE: ./public/img/product/presentation/2.png
/* harmony default export */ var _2 = ({"src":"/_next/static/media/2.98a248cb.png","height":746,"width":1194,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAFCAMAAABPT11nAAAAD1BMVEX29vbv8fHm6Ojl5OLe2dAci7NFAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAI0lEQVQImSXJwQ0AMAyDQIO7/8xVEl4nEdRM2MKJOiJ53Xl9BAQAJeNSURsAAAAASUVORK5CYII="});
;// CONCATENATED MODULE: ./public/img/product/presentation/3.png
/* harmony default export */ var _3 = ({"src":"/_next/static/media/3.fa32f547.png","height":746,"width":1194,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAFCAMAAABPT11nAAAAFVBMVEX5+Pjw8/Pm6urR4+Ha6ObA2NWx1NBJUdloAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAJUlEQVQImSXJwQ0AIADCQAro/iMb4v2aSoAG29LCkFyL07T5ex4EowA4yz28oQAAAABJRU5ErkJggg=="});
;// CONCATENATED MODULE: ./public/img/product/presentation/4.png
/* harmony default export */ var _4 = ({"src":"/_next/static/media/4.7805ba2c.png","height":746,"width":1194,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAFCAMAAABPT11nAAAAD1BMVEX49/fr6+zx8PDW3uLh4eKGoHPWAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAHUlEQVQImWNgYGKAACYWJkYwm5GZkYmRiRGJAQMAA4wAJOVhzp0AAAAASUVORK5CYII="});
;// CONCATENATED MODULE: ./public/img/product/presentation/5.png
/* harmony default export */ var _5 = ({"src":"/_next/static/media/5.f88e3a07.png","height":746,"width":1194,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAFCAMAAABPT11nAAAADFBMVEXo6On29vbv8PDc4OClkLyKAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAI0lEQVQImWNgZGBiBAEGJgYGBiYmBhBkYGZgYEZigBUA1QAAA+gALenTlrcAAAAASUVORK5CYII="});
;// CONCATENATED MODULE: ./public/img/product/presentation/6.png
/* harmony default export */ var _6 = ({"src":"/_next/static/media/6.629a48ca.png","height":746,"width":1194,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAFCAMAAABPT11nAAAAKlBMVEX4+Pf09fHm6ejl1tLw7+6oiYO0w8bi6dZliobg5eXm7Nd4qZzO3dnj4uEpQzlDAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAK0lEQVQImRXGxxEAIAwDMMdOBfafl4tegksyGKCIqDqGyUzSDe92Y/mQmw8OEgCXEm8XCgAAAABJRU5ErkJggg=="});
;// CONCATENATED MODULE: ./public/img/product/presentation/7.png
/* harmony default export */ var _7 = ({"src":"/_next/static/media/7.225b478b.png","height":746,"width":1194,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAFCAMAAABPT11nAAAACVBMVEX19fXt7e7k5OXWaAUfAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAIElEQVQImWNgYGJkAANGJhiLiYmRkRHEZgIDkBwYMAAAAusAJCyNw9YAAAAASUVORK5CYII="});
;// CONCATENATED MODULE: ./public/img/product/presentation/8.png
/* harmony default export */ var _8 = ({"src":"/_next/static/media/8.49a41a93.png","height":746,"width":1194,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAFCAMAAABPT11nAAAAFVBMVEX39/jz8/Pw6+r18u7t1rzk5OXw29Whi81NAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAJUlEQVQImWNgYGSAAEZWJgibkZWJmYWJiRnEZmZhYGODKmBgAAAEUQA0ewmgkQAAAABJRU5ErkJggg=="});
;// CONCATENATED MODULE: ./public/img/product/presentation/9.png
/* harmony default export */ var _9 = ({"src":"/_next/static/media/9.3738e877.png","height":746,"width":1194,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAFCAMAAABPT11nAAAAIVBMVEX39/fx8vLr7Oz09PTk5OV1fWPI19iDfnxgkXCZpJ6CkoXLN83ZAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAKUlEQVQImSXJxxEAIAzEwEs2of+CGUC/HQHEj5F5wURVq0FJY89+25QPBtMAYSYf3SwAAAAASUVORK5CYII="});
;// CONCATENATED MODULE: ./components/product/modules/presentation.tsx
function presentation_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function presentation_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function presentation_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function presentation_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : (typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]);
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function presentation_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function presentation_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            presentation_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function presentation_slicedToArray(arr, i) {
    return presentation_arrayWithHoles(arr) || presentation_iterableToArrayLimit(arr, i) || presentation_unsupportedIterableToArray(arr, i) || presentation_nonIterableRest();
}
function presentation_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return presentation_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return presentation_arrayLikeToArray(o, minLen);
}














var presentation_images = [
    _1,
    _2,
    _3,
    _4,
    _5,
    _6,
    _7,
    _8,
    _9, 
];
var PresentationGallery = function(param) {
    var style = param.style;
    var ref = (0,react.useState)(false), isMounted = ref[0], setIsMounted = ref[1];
    var ref1 = (0,react.useState)(false), pause = ref1[0], setPause = ref1[1];
    var ref2 = presentation_slicedToArray((0,keen_slider_react/* useKeenSlider */.E)({
        loop: true,
        defaultAnimation: {
            duration: 1000
        },
        slides: {
            perView: 1
        },
        created: function() {
            return setIsMounted(true);
        },
        dragStarted: function() {
            setPause(true);
        },
        dragEnded: function() {
            setPause(false);
        }
    }), 2), ref3 = ref2[0], slider = ref2[1];
    (0,react.useEffect)(function() {
        var timer = setInterval(function() {
            if (!pause && slider.current) {
                slider.current.next();
            }
        }, 4000);
        return function() {
            clearInterval(timer);
        };
    }, [
        pause,
        slider
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        style: presentation_objectSpread({
            borderRadius: 16,
            border: "1px solid rgba(0, 0, 0, 0.125)",
            width: "min(100vw - 48px, 520px)"
        }, style),
        className: "jsx-e5dccac8ef3b0979" + " " + "gallery",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                ref: ref3,
                style: {
                    opacity: isMounted ? 1 : 0
                },
                className: "jsx-e5dccac8ef3b0979" + " " + "keen-slider",
                children: presentation_images.map(function(img, i) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("figure", {
                        className: "jsx-e5dccac8ef3b0979" + " " + "keen-slider__slide",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            src: img,
                            alt: "Slide ".concat(i + 1),
                            placeholder: "blur",
                            objectFit: "cover"
                        })
                    }, i);
                })
            }),
            (0,jsx_runtime.jsx)((styled_jsx_default()), {
                id: "e5dccac8ef3b0979",
                children: ".gallery.jsx-e5dccac8ef3b0979{position:relative;max-width:100%;-webkit-border-radius:16px;-moz-border-radius:16px;border-radius:16px;z-index:1;overflow:hidden;line-height:0}.keen-slider.jsx-e5dccac8ef3b0979{min-width:0px;height:100%;width:100%;display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center;-webkit-border-radius:16px;-moz-border-radius:16px;border-radius:16px;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;-ms-touch-action:-ms-pan-y;-ms-touch-action:pan-y;touch-action:pan-y;-webkit-transition:opacity.125s ease-in-out;-moz-transition:opacity.125s ease-in-out;-o-transition:opacity.125s ease-in-out;transition:opacity.125s ease-in-out}.keen-slider__slide.jsx-e5dccac8ef3b0979{display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-webkit-flex-direction:column;-moz-box-orient:vertical;-moz-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-align:end;-webkit-align-items:flex-end;-moz-box-align:end;-ms-flex-align:end;align-items:flex-end;-webkit-flex-shrink:0;-ms-flex-negative:0;flex-shrink:0;max-height:100%;-webkit-border-radius:16px;-moz-border-radius:16px;border-radius:16px}.keen-slider__slide.jsx-e5dccac8ef3b0979>span{-webkit-box-flex:1;-webkit-flex:1 1 auto;-moz-box-flex:1;-ms-flex:1 1 auto;flex:1 1 auto}"
            })
        ]
    });
};
/* harmony default export */ var presentation = (PresentationGallery);

// EXTERNAL MODULE: ./components/demobar.tsx
var demobar = __webpack_require__(3940);
;// CONCATENATED MODULE: ./pages/product.tsx
function product_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function product_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function product_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function product_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : (typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]);
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function product_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function product_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            product_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function product_slicedToArray(arr, i) {
    return product_arrayWithHoles(arr) || product_iterableToArrayLimit(arr, i) || product_unsupportedIterableToArray(arr, i) || product_nonIterableRest();
}
function product_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return product_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return product_arrayLikeToArray(o, minLen);
}




























function TOC() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "jsx-18cd74fbb157b8af" + " " + "toc-container",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                className: "jsx-18cd74fbb157b8af" + " " + "container toc",
                children: Object.entries(sections/* default */.Z).map(function(param) {
                    var _param = product_slicedToArray(param, 2), key = _param[0], section = _param[1];
                    var Icon = section.icon;
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                        href: "#".concat(key),
                        style: {
                            // @ts-expect-error custom property
                            "--colors-icon": section.colorPrimary
                        },
                        className: "jsx-18cd74fbb157b8af",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon, {
                                className: "jsx-18cd74fbb157b8af"
                            }),
                            section.title
                        ]
                    }, key);
                })
            }),
            (0,jsx_runtime.jsx)((styled_jsx_default()), {
                id: "18cd74fbb157b8af",
                children: ".toc.jsx-18cd74fbb157b8af{width:100%;display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;overflow:hidden;padding:12px 28px 12px 48px;-webkit-box-pack:center;-webkit-justify-content:center;-moz-box-pack:center;-ms-flex-pack:center;justify-content:center;gap:48px}.toc-container.jsx-18cd74fbb157b8af{width:100%;position:-webkit-sticky;position:sticky;position:-webkit-sticky;top:60px;background-color:#fff;-webkit-box-shadow:0 1px 0 rgba(0,0,0,.05),0 -1px 0 rgba(0,0,0,.05);-moz-box-shadow:0 1px 0 rgba(0,0,0,.05),0 -1px 0 rgba(0,0,0,.05);box-shadow:0 1px 0 rgba(0,0,0,.05),0 -1px 0 rgba(0,0,0,.05);z-index:9}.toc.jsx-18cd74fbb157b8af a.jsx-18cd74fbb157b8af{display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center;font-size:14px;text-decoration:none;color:inherit}.toc.jsx-18cd74fbb157b8af svg{fill:var(--colors-icon);width:24px;height:24px;margin-right:8px}@media(max-width:520px){.toc-container.jsx-18cd74fbb157b8af{top:unset;bottom:0;position:fixed;-webkit-box-shadow:0 -1px 0 rgba(0,0,0,.05);-moz-box-shadow:0 -1px 0 rgba(0,0,0,.05);box-shadow:0 -1px 0 rgba(0,0,0,.05)}.toc.jsx-18cd74fbb157b8af{display:grid;grid-template-columns:repeat(4,minmax(0,1fr));gap:16px;padding:12px 24px 8px}strong.jsx-18cd74fbb157b8af,strong.jsx-18cd74fbb157b8af+span.jsx-18cd74fbb157b8af{display:none}.toc.jsx-18cd74fbb157b8af a.jsx-18cd74fbb157b8af{-webkit-box-orient:vertical;-webkit-box-direction:normal;-webkit-flex-direction:column;-moz-box-orient:vertical;-moz-box-direction:normal;-ms-flex-direction:column;flex-direction:column;gap:2px}}@supports(backdrop-filter:saturate(180%)blur(8px))or (-webkit-backdrop-filter:saturate(180%)blur(8px)){.toc-container.jsx-18cd74fbb157b8af{background-color:rgba(255,255,255,.875);-webkit-backdrop-filter:saturate(180%)blur(8px);backdrop-filter:saturate(180%)blur(8px)}}"
            })
        ]
    });
}
function Header() {
    var t = (0,index_modern/* useI18n */.QT)().t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("header", {
        className: "jsx-c4bc2dae0fdef27f",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "jsx-c4bc2dae0fdef27f",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("h1", {
                        className: "jsx-c4bc2dae0fdef27f",
                        children: [
                            "Everything you need to run a",
                            " ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                style: {
                                    whiteSpace: "nowrap"
                                },
                                className: "jsx-c4bc2dae0fdef27f",
                                children: "world-class"
                            }),
                            " climate",
                            " ",
                            t("common.program"),
                            "."
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                        className: "jsx-c4bc2dae0fdef27f",
                        children: [
                            "Make a plan designed for real-world results with our all-in-one solution. Trusted by some of the world\u2019s most",
                            " ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: "/customers",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    className: "jsx-c4bc2dae0fdef27f",
                                    children: "forward-thinking companies"
                                })
                            }),
                            "."
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: "/demo",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            className: "jsx-c4bc2dae0fdef27f" + " " + "button primary",
                            children: "Request a demo"
                        })
                    })
                ]
            }),
            (0,jsx_runtime.jsx)((styled_jsx_default()), {
                id: "c4bc2dae0fdef27f",
                children: "header.jsx-c4bc2dae0fdef27f{padding:24px 16px 0}h1.jsx-c4bc2dae0fdef27f{margin-top:0;margin-bottom:24px;font-size:42px;line-height:1.125}p.jsx-c4bc2dae0fdef27f{font-size:18px;margin-bottom:24px}@media screen and (min-width:520px){header.jsx-c4bc2dae0fdef27f{margin:0 auto;padding:48px 32px 24px;text-align:center}h1.jsx-c4bc2dae0fdef27f{letter-spacing:-.04em;font-size:64px;max-width:28ch;margin:16px auto 24px}p.jsx-c4bc2dae0fdef27f{max-width:56ch;font-size:22px;margin:24px auto}}p.jsx-c4bc2dae0fdef27f a.jsx-c4bc2dae0fdef27f{font-weight:bold}.button.jsx-c4bc2dae0fdef27f{font-size:20px;padding:8px 24px}"
            })
        ]
    });
}
function Hero() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("figure", {
        className: "jsx-2aee2646ad48a7fd",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                alt: "Screenshot of the Watershed Dashboard",
                src: hero,
                layout: "responsive",
                placeholder: "blur",
                objectPosition: "top center",
                objectFit: "cover",
                priority: true
            }),
            (0,jsx_runtime.jsx)((styled_jsx_default()), {
                id: "2aee2646ad48a7fd",
                children: "figure.jsx-2aee2646ad48a7fd{background-image:-webkit-linear-gradient(#fff,#f7f7f9);background-image:-moz-linear-gradient(#fff,#f7f7f9);background-image:-o-linear-gradient(#fff,#f7f7f9);background-image:linear-gradient(#fff,#f7f7f9)}@media screen and (max-width:520px){figure.jsx-2aee2646ad48a7fd{margin-top:-16px;position:relative;z-index:-1}figure.jsx-2aee2646ad48a7fd img{width:140vw!important;max-width:none!important;margin-left:-10vw!important}}@media screen and (min-width:820px){figure.jsx-2aee2646ad48a7fd>span{max-width:80vw;margin:auto!important}}"
            })
        ]
    });
}
var __N_SSG = true;
function ProductPage() {
    var t = (0,index_modern/* useI18n */.QT)().t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(meta/* default */.Z, {
                title: "Product",
                description: "Build a world-class climate strategy and a detailed plan to achieve real results. Measure your footprint, reduce and remove emissions, and report on progress, quickly. Trusted by some of the world\u2019s most forward-thinking companies."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(navbar/* default */.Z, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Header, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Hero, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TOC, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Section, product_objectSpread({
                number: 1
            }, sections/* default.measure */.Z.measure, {
                headline: "Count every ton of carbon, quickly.",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(ModuleColumn, {
                        headline: "Rigorous carbon accounting, powered by the latest climate science",
                        doubleHeight: true,
                        graphic: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            style: {
                                margin: "auto",
                                lineHeight: 0,
                                width: "100%"
                            },
                            className: "jsx-b9b010931f59ad00" + " " + "padded-box",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ClimateScienceVisual, {})
                        }),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                className: "jsx-b9b010931f59ad00",
                                children: [
                                    "Watershed\u2019s carbon data engine ",
                                    t("common.analyzes"),
                                    " emissions for every line item of your business. We measure Scope 1, 2, and 3 of the ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        href: "https://ghgprotocol.org/",
                                        className: "jsx-b9b010931f59ad00",
                                        children: "Greenhouse Gas Protocol"
                                    }),
                                    ", and have developed state-of-the-art methodologies for",
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: "/blog/decoupling-work-from-carbon",
                                        children: "remote work"
                                    }),
                                    ", ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: "/blog/carbon-in-the-cloud",
                                        children: "cloud computing"
                                    }),
                                    ", cryptocurrencies, food, apparel, and more."
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "jsx-b9b010931f59ad00",
                                children: "We integrate tens of thousands of emissions factors from government publications (including DEFRA and EPA), LCA dashboards (like Ecoinvent), academic research, and company reports. Tested by the most exacting auditors."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SuppliersModule, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ModuleColumn, {
                        headline: "Know your footprint in weeks, not months",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "jsx-b9b010931f59ad00",
                            children: "Upload raw data on financials, buildings, travel, and more; we take care of the rest. Drag-and-drop files in the dashboard, or automate data collection with our API. Your footprint auto-refreshes with any new data, so you\u2019re never waiting weeks for a new PDF."
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ModuleColumn, {
                        graphic: /*#__PURE__*/ (0,jsx_runtime.jsx)(Screenshot, {
                            src: drilldown,
                            alt: "Drilldown",
                            caption: "Go deep on your data with a real-time dashboard that enables ".concat(t("common.categorization"), ", filtering, and drill-downs by GHGP scope and category, vendor, location, and more."),
                            cropped: true
                        }),
                        headline: "Turn numbers into action",
                        doubleWidth: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                            className: "jsx-b9b010931f59ad00",
                            children: [
                                t("common.Analyze"),
                                " your emissions with a real-time dashboard that enables line-by-line drill-downs by scope, category, vendor, location, and more, with dollar-for-dollar benchmarks against others in your industry."
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Testimonial, {
                        href: "/blog/insights-from-shopify-remote-era-climate-journey",
                        logo: shopify,
                        logoAlt: "Shopify logo",
                        quote: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                "We went from generic",
                                " ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                    className: "jsx-b9b010931f59ad00",
                                    children: "industry averages to a live model"
                                }),
                                "\u2014built on our actual data\u2014",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                    className: "jsx-b9b010931f59ad00",
                                    children: "in just a few weeks"
                                }),
                                ". And this modelling opened up a thousand new routes to drive down emissions across our value chain."
                            ]
                        }),
                        name: "Stacy Kauk",
                        credential: "Director of Shopify\u2019s Sustainability Fund"
                    })
                ]
            })),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Section, product_objectSpread({
                number: 2,
                headline: "Real results, not empty promises."
            }, sections/* default.reduce */.Z.reduce, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ModuleColumn, {
                        headline: "Set goals and take action",
                        graphic: /*#__PURE__*/ (0,jsx_runtime.jsx)(Screenshot, {
                            src: reductions,
                            alt: "Screenshot of the Watershed Reductions product",
                            cropped: true
                        }),
                        doubleWidth: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                            className: "jsx-b9b010931f59ad00",
                            children: [
                                t("common.Analyze"),
                                " your emissions and eliminate them from every corner of your business. Build your detailed plan based on a state-of-the-art projection of future emissions. Set ambitious",
                                " ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    href: "/blog/a-standard-for-net-zero",
                                    children: "Net Zero"
                                }),
                                " goals in line with the rigorous standards of the",
                                " ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    href: "/blog/science-based-targets-a-guide-for-companies",
                                    children: "Science-Based Targets initiative (SBTi)"
                                }),
                                "."
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CleanEnergyModule, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CSMModule, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Testimonial, {
                        href: "/blog/square-building-a-world-class-climate-program-in-six-months",
                        logo: block,
                        logoAlt: "Block logo",
                        quote: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                "Watershed allowed Block to",
                                " ",
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("strong", {
                                    className: "jsx-b9b010931f59ad00",
                                    children: [
                                        "build a powerful and deeply specific climate action",
                                        " ",
                                        t("common.program"),
                                        " literally from scratch"
                                    ]
                                }),
                                ". They move fast and with precision which has been a perfect alliance. I consider them our long-term, end-to-end sustainability partners."
                            ]
                        }),
                        name: "Neil Jorgensen",
                        credential: "Global ESG Lead, Block"
                    })
                ]
            })),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Section, product_objectSpread({
                number: 3,
                headline: "Fund carbon removal that matters."
            }, sections/* default.remove */.Z.remove, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(MarketplaceModule, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PortfolioBuilderModule, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(RemovalPrimerModule, {})
                ]
            })),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Section, product_objectSpread({
                number: 4,
                headline: "Carbon reporting as rigorous as your financials."
            }, sections/* default.report */.Z.report, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(ModuleColumn, {
                        headline: "Investor-grade reporting",
                        graphic: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            style: {
                                paddingTop: "0 !important",
                                margin: "0 auto"
                            },
                            className: "jsx-b9b010931f59ad00" + " " + "padded-box",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StandardsLogos, {})
                        }),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                className: "jsx-b9b010931f59ad00",
                                children: [
                                    "Export audit-ready, investor-grade reports, formatted to meet the",
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        href: "https://ghgprotocol.org/",
                                        className: "jsx-b9b010931f59ad00",
                                        children: "gold standard for carbon accounting"
                                    }),
                                    ", whenever you need them."
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                className: "jsx-b9b010931f59ad00",
                                children: [
                                    "Watershed reports are consistent with",
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: "/blog/tcfd-standards-what-companies-need-to-know",
                                        children: "TCFD"
                                    }),
                                    ", ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        href: "https://www.cdp.net/en",
                                        className: "jsx-b9b010931f59ad00",
                                        children: "CDP"
                                    }),
                                    ", SASB, and GRI global standards, as well as country-specific ones such as",
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: "/blog/eu-and-uk-climate-disclosure-programmes-an-overview",
                                        children: "SECR in the UK"
                                    }),
                                    ". Our climate expert team can prepare and submit your CDP report, and work hand-in-hand with third party auditors."
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ModuleColumn, {
                        headline: "Keep your whole ".concat(t("common.organization"), " in the loop"),
                        graphic: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            style: {
                                alignSelf: "center",
                                justifySelf: "center",
                                padding: "8px 12px 24px",
                                marginTop: "auto",
                                maxWidth: "100%"
                            },
                            className: "jsx-b9b010931f59ad00",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(presentation, {}),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    style: {
                                        textAlign: "center",
                                        fontSize: 14,
                                        marginTop: 8,
                                        marginBottom: 0,
                                        color: "#6d7384",
                                        lineHeight: 1.25
                                    },
                                    className: "jsx-b9b010931f59ad00",
                                    children: "Present your latest footprint data anytime"
                                })
                            ]
                        }),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                            className: "jsx-b9b010931f59ad00",
                            children: [
                                "Dynamic, real-time presentations keep employees, leaders, and stakeholders engaged on your climate ",
                                t("common.program"),
                                ". Give teams the tools and data they need, with ",
                                t("common.customizable"),
                                ", granular access permissions."
                            ]
                        })
                    })
                ]
            })),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "jsx-b9b010931f59ad00" + " " + "container",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(demobar/* default */.Z, {})
            }),
            (0,jsx_runtime.jsx)((styled_jsx_default()), {
                id: "b9b010931f59ad00",
                children: ":root{--module-color:hsl(215, 10%, 95.49%);--module-color-hover:hsl(215, 10%, 89.8%);--module-color-quote:hsl(215, 10%, 87.06%);--module-color-hover-quote:hsl(215, 10%, 77.06%);--module-gap:32px;--module-radius:16px}@media(min-width:820px){.padded-box{padding:36px 40px}}html{scroll-behavior:smooth}"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(footer/* default */.Z, {})
        ]
    });
};


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [109,89,854,774,888,179], function() { return __webpack_exec__(5407); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);